import type { BasicIconProps as IconProps } from "./Icon";
import { IconWrapper } from "./Icon";

export const AnnouncementIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        clipRule="evenodd"
        d="M10.9544 3.86071C12.3863 3.07393 14.3408 2 17 2C18.6183 2 19.8879 3.13883 20.6967 4.55411C21.5216 5.99769 22 7.92522 22 10C22 12.0748 21.5216 14.0023 20.6967 15.4459C19.8879 16.8612 18.6183 18 17 18C14.3689 18 12.4277 16.9487 11 16.1643V19C11 20.6568 9.65685 22 8 22C6.34315 22 5 20.6568 5 19V15C5 14.9501 5.00122 14.9004 5.00363 14.8511C4.07607 14.5651 3.37242 13.9068 2.92169 13.2307C2.31206 12.3163 2 11.1682 2 10C2 8.8318 2.31206 7.68372 2.92169 6.76928C3.52199 5.86882 4.57095 5 6 5H8C8.79448 5 9.52261 4.64684 10.8681 3.90812L10.9544 3.86071ZM8 15H7V19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19V15.1835C8.64578 15.0604 8.32856 15 8 15ZM11.8306 14.3387C11.4589 14.1346 11.0945 13.9346 10.7298 13.7539C9.85685 13.3214 8.98199 13 8 13H6C5.92567 13 5.85229 12.9939 5.78007 12.9821C4.77898 12.8178 4 11.5454 4 10C4 8.34315 4.89543 7 6 7H8C9.3923 7 10.5692 6.35383 11.8306 5.66126C12.2297 5.44218 12.6372 5.21845 13.0626 5.00906C12.5424 6.0719 12.1939 7.34936 12.0606 8.73044C12.0548 8.77066 12.0502 8.81128 12.0469 8.85229C12.016 9.22725 12 9.61058 12 10C12 9.99999 12 10 12 10C12 10.3894 12.0159 10.7728 12.0469 11.1478C12.0502 11.1888 12.0549 11.2295 12.0606 11.2697C12.1939 12.6507 12.5424 13.9281 13.0626 14.9909C12.6372 14.7816 12.2297 14.5578 11.8306 14.3387ZM14.4174 12.9733C14.5852 13.5298 14.7968 14.0284 15.0398 14.4536C15.6788 15.5718 16.4092 16 17 16C17.5908 16 18.3212 15.5718 18.9602 14.4536C19.583 13.3637 20 11.7912 20 10C20 8.20879 19.583 6.63632 18.9602 5.54639C18.3212 4.42817 17.5908 4 17 4C16.4092 4 15.6788 4.42817 15.0398 5.54639C14.7968 5.97161 14.5852 6.47028 14.4174 7.02673C15.279 7.05606 16.1371 7.12403 16.83 7.33006C17.2333 7.44998 17.7746 7.67011 18.2292 8.12468C18.7477 8.64317 19 9.31245 19 10C19 10.6876 18.7477 11.3569 18.2292 11.8754C17.7747 12.3299 17.2333 12.5501 16.83 12.67C16.1371 12.876 15.279 12.944 14.4174 12.9733ZM14 10C14 9.99999 14 10 14 10C14 9.66394 14.0147 9.33559 14.0426 9.01667C14.5465 9.02908 14.9859 9.05074 15.361 9.08853C15.5859 9.11119 15.7877 9.13966 15.9663 9.17541C15.9888 9.17991 16.0109 9.18452 16.0327 9.18926C16.6775 9.32963 17 9.57414 17 10C17 10.4259 16.6776 10.6704 16.0327 10.8108C16.0109 10.8155 15.9888 10.8201 15.9663 10.8246C15.7877 10.8604 15.5859 10.8889 15.361 10.9115C14.9859 10.9493 14.5465 10.971 14.0426 10.9834C14.0147 10.6645 14 10.3361 14 10ZM15.7022 8.8321C15.7108 8.82931 15.7148 8.8277 15.7146 8.82759C15.7144 8.82751 15.7115 8.82843 15.7061 8.83053C15.7049 8.831 15.7036 8.83152 15.7022 8.8321Z"
        fill={props.fill}
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const BlackboardIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <rect
        x="2"
        y="4"
        width="20"
        height="16"
        fill="none"
        stroke={props.fill}
      />
      <rect x="3" y="5" width="18" height="14" mask="url(#teacher-letters)" />
      <mask id="teacher-letters">
        <rect x="0" y="0" height="100%" width="100%" fill="white" />
        <path
          fill="none"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 14L7 8L9 14M5 12H8M11 8V14A2 1.2 0 0 0 11 11A2 1.5 0 0 0 11 8M19 9A2 3 0 1 0 19 13"
        />
      </mask>
    </svg>
  </IconWrapper>
);

export const CheckboxIcon = {
  Unchecked: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 8a5 5 0 015-5h8a5 5 0 015 5v8a5 5 0 01-5 5H8a5 5 0 01-5-5V8zm5-3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V8a3 3 0 00-3-3H8z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Indeterminate: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V8a5 5 0 00-5-5H8zM5 8a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H8a3 3 0 01-3-3V8zm3 3a1 1 0 100 2h8a1 1 0 100-2H8z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Checked: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.143 3A5.143 5.143 0 003 8.143v7.714A5.143 5.143 0 008.143 21h7.714A5.143 5.143 0 0021 15.857V8.143A5.143 5.143 0 0015.857 3H8.143zm8.564 7.707a1 1 0 00-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l5-5z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const DeleteIcon = {
  Small: ({ size = 12, viewBox = "0 0 12 12", ...props }: IconProps) => (
    <IconWrapper size={size} viewBox={viewBox} {...props}>
      <svg>
        <path
          clipRule="evenodd"
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM8.53033 3.46967C8.82323 3.76257 8.82323 4.23744 8.53033 4.53033L7.06066 6L8.53033 7.46967C8.82323 7.76257 8.82323 8.23744 8.53033 8.53033C8.23744 8.82323 7.76257 8.82323 7.46967 8.53033L6 7.06066L4.53033 8.53033C4.23744 8.82323 3.76257 8.82323 3.46967 8.53033C3.17678 8.23744 3.17678 7.76257 3.46967 7.46967L4.93934 6L3.46967 4.53033C3.17678 4.23744 3.17678 3.76257 3.46967 3.46967C3.76257 3.17678 4.23744 3.17678 4.53033 3.46967L6 4.93934L7.46967 3.46967C7.76257 3.17678 8.23744 3.17678 8.53033 3.46967Z"
          fill={props.fill}
          fillRule="evenodd"
        />
      </svg>
    </IconWrapper>
  ),
};

export const StarIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.783 8.834a.438.438 0 01-.33.233l-4.077.577a.424.424 0 00-.243.727l2.95 2.8a.42.42 0 01.127.377L7.513 17.5c-.061.349.314.615.636.45l3.647-1.866a.45.45 0 01.408 0l3.647 1.866c.322.165.697-.101.636-.45l-.696-3.952a.42.42 0 01.126-.378l2.95-2.799a.424.424 0 00-.243-.727l-4.077-.577a.438.438 0 01-.33-.233l-1.824-3.596a.444.444 0 00-.786 0L9.783 8.834zM15.631 7.2l-1.454-2.868c-.902-1.777-3.452-1.777-4.354 0L8.37 7.201l-3.273.462c-1.938.275-2.871 2.706-1.34 4.16l2.336 2.215-.549 3.115c-.37 2.097 1.836 3.438 3.517 2.578L12 18.226l2.94 1.505c1.681.86 3.886-.481 3.517-2.578l-.55-3.115 2.337-2.216c1.532-1.453.598-3.884-1.34-4.159l-3.273-.462z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.177 4.333l1.454 2.868 3.273.462c1.938.275 2.872 2.706 1.34 4.16l-2.336 2.215.549 3.115c.37 2.097-1.836 3.438-3.517 2.578L12 18.226l-2.94 1.505c-1.681.86-3.886-.481-3.517-2.578l.55-3.115-2.337-2.216c-1.531-1.453-.598-3.884 1.34-4.159l3.273-.462 1.454-2.868c.902-1.777 3.452-1.777 4.354 0z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.176 4.333l.124.246-1.488 1.488-.42-.83a.444.444 0 00-.786 0L9.782 8.835a.438.438 0 01-.33.233l-4.077.577a.424.424 0 00-.243.727l1.732 1.644-1.415 1.414-1.694-1.607c-1.532-1.453-.598-3.884 1.34-4.159l3.273-.462 1.454-2.868c.902-1.777 3.452-1.777 4.354 0zM6.168 19.246l-.46.461a1 1 0 01-1.415-1.414l14-14a1 1 0 111.414 1.414l-1.814 1.814 1.01.142c1.938.275 2.871 2.706 1.34 4.16l-2.336 2.215.549 3.115c.369 2.097-1.836 3.438-3.517 2.578l-2.94-1.505-2.94 1.505c-.994.508-2.171.247-2.891-.485zm1.422-1.421c.12.158.35.231.558.125l3.647-1.866a.45.45 0 01.408 0l3.647 1.866c.322.165.697-.101.636-.45l-.697-3.952a.42.42 0 01.126-.378l2.951-2.799a.424.424 0 00-.243-.727l-2.5-.354-8.533 8.535z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const RadioButtonIcon = {
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  On: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 12a7 7 0 1114 0 7 7 0 01-14 0zm7-9a9 9 0 100 18 9 9 0 000-18zm0 14a5 5 0 100-10 5 5 0 000 10z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const GiftIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.146 5a.854.854 0 00-.764.472L13.618 7H15a1 1 0 001-1v-.146A.854.854 0 0015.146 5zm-4.764 2l-.764-1.528A.854.854 0 008 5.854V6a1 1 0 001 1h1.382zM6.171 7C6.06 6.687 6 6.35 6 6v-.146a2.854 2.854 0 015.407-1.276L12 5.764l.593-1.186A2.854 2.854 0 0118 5.854V6c0 .35-.06.687-.17 1H18a2 2 0 012 2v2a2 2 0 01-1.017 1.742c.011.084.017.17.017.258v5a2 2 0 01-2 2H7a2 2 0 01-2-2v-5c0-.088.006-.174.017-.258A2 2 0 014 11V9a2 2 0 012-2h.17zM9 9H6v2h12V9H9zm8 9v-5h-4v5h4zm-6-5v5H7v-5h4z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.146 5a.854.854 0 00-.764.472L13.618 7H15a1 1 0 001-1v-.146A.854.854 0 0015.146 5zm-4.764 2l-.764-1.528A.854.854 0 008 5.854V6a1 1 0 001 1h1.382zM6.171 7C6.06 6.687 6 6.35 6 6v-.146a2.854 2.854 0 015.407-1.276L12 5.764l.593-1.186A2.854 2.854 0 0118 5.854V6c0 .35-.06.687-.17 1H19a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h1.17zM5 13h6v7H7a2 2 0 01-2-2v-5zm14 0h-6v7h4a2 2 0 002-2v-5z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const HeartIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 19c-1.714-1.167-8-5.833-8-9.917C4 6.75 5.79 5 8 5c1.164 0 2.053.518 2.718 1.163.596.578 1.012 1.257 1.282 1.754.27-.497.686-1.176 1.282-1.754C13.947 5.518 14.836 5 16 5c2.21 0 4 1.75 4 4.083 0 4.084-6.286 8.75-8 9.917zm0-14.378C12.938 3.748 14.246 3 16 3c3.328 0 6 2.66 6 6.083 0 1.52-.577 2.939-1.293 4.135-.724 1.212-1.678 2.34-2.635 3.317-1.914 1.953-4.032 3.496-4.947 4.118a2 2 0 01-2.25 0c-.915-.622-3.033-2.165-4.947-4.118-.957-.977-1.91-2.105-2.635-3.317C2.577 12.022 2 10.603 2 9.083 2 5.66 4.673 3 8 3c1.754 0 3.062.748 4 1.622z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.622C12.938 3.748 14.246 3 16 3c3.328 0 6 2.66 6 6.083 0 1.52-.577 2.939-1.293 4.135-.724 1.212-1.678 2.34-2.635 3.317-1.914 1.953-4.032 3.496-4.947 4.118a2 2 0 01-2.25 0c-.915-.622-3.033-2.165-4.947-4.118-.957-.977-1.91-2.105-2.635-3.317C2.577 12.022 2 10.603 2 9.083 2 5.66 4.673 3 8 3c1.754 0 3.062.748 4 1.622z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const LockClosedIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3a5 5 0 00-5 5v1a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3V8a5 5 0 00-5-5zm3 6V8a3 3 0 10-6 0v1h6zm-9 3a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H7a1 1 0 01-1-1v-6z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3a5 5 0 00-5 5v1a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3V8a5 5 0 00-5-5zm3 6V8a3 3 0 10-6 0v1h6z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const LockOpenIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0a5 5 0 00-5 5v4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3H9V5a3 3 0 116 0 1 1 0 102 0 5 5 0 00-5-5zM8 11H7a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1v-6a1 1 0 00-1-1H8z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0a5 5 0 00-5 5v4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3H9V5a3 3 0 116 0 1 1 0 102 0 5 5 0 00-5-5z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const PlusIcon = {
  Simple: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 011-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3V8a1 1 0 011-1z"
          fill={props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 19a7 7 0 100-14 7 7 0 000 14zm0 2a9 9 0 100-18 9 9 0 000 18z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-4a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2H9a1 1 0 110-2h2V9a1 1 0 011-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const MinusIcon = {
  Simple: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 12a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 19a7 7 0 100-14 7 7 0 000 14zm0 2a9 9 0 100-18 9 9 0 000 18z"
          fill={props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 12a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zM8 11a1 1 0 100 2h8a1 1 0 100-2H8z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const CheckmarkIcon = {
  Outline: {
    On: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-5.293-1.293a1 1 0 00-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l5-5z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
    Off: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
  },
  FilledOn: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm4.707-11.293a1 1 0 00-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l5-5z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  SimpleOn: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L10 15.5858L18.2929 7.29289C18.6834 6.90237 19.3166 6.90237 19.7071 7.29289Z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const ScreenSizeIcon = {
  Maximize: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 11a1 1 0 102 0V6a1 1 0 00-1-1h-5a1 1 0 100 2h4v4zM7 13a1 1 0 10-2 0v5a1 1 0 001 1h5a1 1 0 100-2H7v-4z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Minimize: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 5a1 1 0 10-2 0v5a1 1 0 001 1h5a1 1 0 100-2h-4V5zM9 19a1 1 0 102 0v-5a1 1 0 00-1-1H5a1 1 0 100 2h4v4z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const FileFormatIcon = {
  TXT: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 1a3 3 0 00-3 3v14a3 3 0 003 3h1v1a2 2 0 002 2h12a2 2 0 002-2v-6a2 2 0 00-2-2h-2V8.828a3 3 0 00-.467-1.608 1.273 1.273 0 00-.252-.354L13.134 1.72a1.271 1.271 0 00-.353-.252A3 3 0 0011.171 1H6zm11 13V9h-3a3 3 0 01-3-3V3H6a1 1 0 00-1 1v14a1 1 0 001 1h1v-3a2 2 0 012-2h8zm-4-8V4.415L15.587 7H14a1 1 0 01-1-1zM9.385 17.64v-.864h3.456v.864h-1.224V21h-1.008v-3.36H9.384zm6.24 1.188L16.968 21h-1.14L15 19.506 14.172 21h-1.14l1.344-2.172-1.248-2.052h1.098l.774 1.38.774-1.38h1.098l-1.248 2.052zm1.535-2.052v.864h1.224V21h1.008v-3.36h1.224v-.864H17.16z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  CSV: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 4a3 3 0 013-3h5.172a3 3 0 011.607.467c.126.06.246.143.355.252l5.146 5.147c.11.108.192.228.252.353A3 3 0 0119 8.829V14h2a2 2 0 012 2v6a2 2 0 01-2 2H10a2 2 0 01-2-2v-1H6a3 3 0 01-3-3V4zm5 15v-3a2 2 0 012-2h7V9h-3a3 3 0 01-3-3V3H6a1 1 0 00-1 1v14a1 1 0 001 1h2zm5-14.586V6a1 1 0 001 1h1.585L13 4.414zM9.617 18.888c0 1.218.726 2.208 2.136 2.208 1.278 0 1.914-.9 1.992-1.692l-.978-.192c-.048.39-.33 1.02-1.002 1.02-.726 0-1.14-.6-1.14-1.344 0-.744.414-1.344 1.14-1.344.672 0 .954.63 1.002 1.02l.978-.192c-.078-.792-.714-1.692-1.992-1.692-1.41 0-2.136.99-2.136 2.208zm6.1-.57c-.552-.084-.63-.252-.63-.414 0-.18.156-.408.582-.408.474 0 .624.396.624.672l.948-.192c-.03-.666-.534-1.296-1.56-1.296-1.002 0-1.596.552-1.596 1.26 0 .744.384 1.158 1.584 1.35.534.09.72.234.72.486 0 .234-.21.504-.72.504-.588 0-.756-.492-.756-.864l-.972.192c0 .78.576 1.488 1.728 1.488 1.128 0 1.728-.636 1.728-1.38 0-.96-.69-1.254-1.68-1.398zm3.742 1.602l1.056-3.144h1.056L19.987 21h-1.056l-1.584-4.224h1.056l1.056 3.144z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const TimerIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2a1 1 0 011-1h4a1 1 0 110 2h-1v.055a8.957 8.957 0 014.615 1.91 1 1 0 011.592-1.172l1 1a1 1 0 01-1.173 1.592A9 9 0 113 12c0-4.633 3.5-8.448 8-8.945V3h-1a1 1 0 01-1-1zm3 3a7 7 0 100 14 7 7 0 000-14z"
          fill={props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8a1 1 0 011 1v2.586l1.207 1.207a1 1 0 01-1.414 1.414L11 12.414V9a1 1 0 011-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1a1 1 0 000 2h1v.055A9.001 9.001 0 0012 21a9 9 0 007.034-14.615 1 1 0 001.173-1.592l-1-1a1 1 0 00-1.592 1.173A8.957 8.957 0 0013 3.055V3h1a1 1 0 100-2h-4zm3 8a1 1 0 10-2 0v3.414l1.793 1.793a1 1 0 001.414-1.414L13 11.586V9z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const StreakIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.331 2.056A1 1 0 0114 3v6a1 1 0 001 1h4a1 1 0 01.78 1.625l-8 10A1 1 0 0110 21v-6a1 1 0 00-1-1H5a1 1 0 01-.78-1.625l8-10a1 1 0 011.111-.319zM7.081 12H9a3 3 0 013 3v3.15L16.92 12H15a3 3 0 01-3-3V5.85L7.08 12z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.331 2.056A1 1 0 0114 3v6a1 1 0 001 1h4a1 1 0 01.78 1.625l-8 10A1 1 0 0110 21v-6a1 1 0 00-1-1H5a1 1 0 01-.78-1.625l8-10a1 1 0 011.111-.319z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const EyeIcon = {
  On: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.712 12.769c-.107.18-.265.434-.472.735a15.38 15.38 0 01-1.844 2.207C17.776 17.311 15.288 19 12 19c-3.288 0-5.776-1.688-7.397-3.289a15.376 15.376 0 01-2.316-2.942c-.153-.258-.303-.51-.286-.822.014-.268.153-.492.286-.716.108-.18.265-.434.472-.735a15.382 15.382 0 011.844-2.207C6.223 6.689 8.712 5 12 5c3.288 0 5.776 1.688 7.396 3.289a15.373 15.373 0 012.317 2.942c.15.253.302.516.286.822-.014.265-.154.494-.287.716zM4.162 12a13.38 13.38 0 001.847 2.288C7.426 15.688 9.438 17 11.999 17c2.563 0 4.574-1.312 5.992-2.712A13.381 13.381 0 0019.838 12a13.382 13.382 0 00-1.847-2.288C16.574 8.311 14.56 7 12 7 9.438 7 7.426 8.312 6.009 9.711A13.385 13.385 0 004.162 12z"
          fill={props.fill}
        />
        <path d="M16 12a4 4 0 11-8 0 4 4 0 018 0z" fill={props.fill} />
      </svg>
    </IconWrapper>
  ),
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.496 9.136a1 1 0 011.368.36 14.717 14.717 0 001.789 2.47C7.08 13.535 9.16 15 12 15c2.377 0 4.39-1.301 5.87-2.721A15.428 15.428 0 0020 9.714a8.144 8.144 0 00.132-.21l.004-.008a1 1 0 011.728 1.008L21 10c.864.504.864.504.863.505l-.001.002-.003.006-.011.018a7.599 7.599 0 01-.17.271 17.51 17.51 0 01-1.27 1.692l1.3 1.299a1 1 0 01-1.415 1.414l-1.269-1.269a13.031 13.031 0 01-2.69 1.935l.57 1.198a1 1 0 01-1.807.858l-.615-1.293A8.72 8.72 0 0112 17c-.89 0-1.717-.113-2.482-.312l-.622 1.256a1 1 0 01-1.792-.888l.53-1.072a11.344 11.344 0 01-2.753-1.95l-1.174 1.173a1 1 0 11-1.414-1.414l1.238-1.239c-.612-.77-1.074-1.5-1.395-2.05a1 1 0 01.36-1.368z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const BellIcon = {
  On: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.126 18H7a3 3 0 01-3-3v-.172a3 3 0 01.879-2.12l.828-.83A1 1 0 006 11.173V9a6 6 0 1112 0v2.172a1 1 0 00.293.707l.828.828A3 3 0 0120 14.828V15a3 3 0 01-3 3h-1.126a4.002 4.002 0 01-7.748 0zM8 9a4 4 0 118 0v2.172a3 3 0 00.879 2.12l.828.83a1 1 0 01.293.706V15a1 1 0 01-1 1H7a1 1 0 01-1-1v-.172a1 1 0 01.293-.707l.828-.828A3 3 0 008 11.172V9zm2.268 9a2 2 0 003.464 0h-3.464z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          d="M12 3c1.34 0 2.576.439 3.575 1.18l-1.438 1.438A4 4 0 008 9v2.172c0 .222-.025.443-.073.657l-3.85 3.85A3.01 3.01 0 014 15v-.172a3 3 0 01.879-2.12l.828-.83A1 1 0 006 11.173V9a6 6 0 016-6z"
          fill={props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.508 7.076l1.453-1.452 1.332-1.331a1 1 0 111.414 1.414l-1.875 1.876c.11.454.168.929.168 1.417v2.172a1 1 0 00.293.707l.828.828A3 3 0 0120 14.828V15a3 3 0 01-3 3h-1.126a4.002 4.002 0 01-7.748 0h-.712l-.707.707A1 1 0 015.2 17.4l-.01-.007 1.458-1.457h.001l8.86-8.859h-.001zM16 9.414L9.414 16H17a1 1 0 001-1v-.172a1 1 0 00-.293-.707l-.828-.828A3 3 0 0116 11.172V9.414zM10.268 18a2 2 0 003.464 0h-3.464z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const FlagIcon = {
  On: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5a1 1 0 011-1h9a1 1 0 01.707 1.707L13.414 6H21a1 1 0 01.707 1.707L18.414 11l3.293 3.293A1 1 0 0121 16H11a1 1 0 01-1-1v-1H5v7a1 1 0 11-2 0V5zm2 7h5V7c0-.276.112-.527.293-.708L10.586 6H5v6zm7 1V8h6.586l-2.293 2.293a1 1 0 000 1.414L18.586 14H12v-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.707 3.707a1 1 0 00-1.414-1.414l-16 16a1 1 0 101.414 1.414L3 18.414V21a1 1 0 102 0v-4.586L7.414 14H10v1a1 1 0 001 1h10a1 1 0 00.707-1.707L18.414 11l3.293-3.293A1 1 0 0021 6h-5.586l2.293-2.293zM12 9.414L13.414 8h5.172l-2.293 2.293a1 1 0 000 1.414L18.586 14H12V9.414zm-2 2L9.414 12H10v-.586zM4 4h8.086l-2 2H5v5.086l-2 2V5a1 1 0 011-1z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const CCIcon = {
  On: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.931 6.308C19.657 6.48 21 7.985 21 9.918v4.163c0 1.934-1.343 3.438-3.069 3.611-1.71.172-3.756.308-5.931.308-2.175 0-4.22-.136-5.931-.308C4.343 17.52 3 16.015 3 14.082V9.918C3 7.985 4.343 6.48 6.069 6.308A60.068 60.068 0 0112 6c2.175 0 4.22.136 5.931.308zM1 9.918c0-2.86 2.024-5.315 4.87-5.6A62.066 62.066 0 0112 4c2.256 0 4.37.141 6.13.318 2.846.285 4.87 2.74 4.87 5.6v4.163c0 2.86-2.024 5.316-4.87 5.601-1.76.177-3.874.318-6.13.318s-4.37-.141-6.13-.318c-2.846-.285-4.87-2.74-4.87-5.6V9.918zM6.216 8.81C6.96 8.159 7.856 8 8.5 8c.99 0 2.223.347 2.873 1.513a1 1 0 11-1.746.974C9.47 10.207 9.11 10 8.5 10c-.355 0-.71.091-.966.315-.23.2-.534.643-.534 1.685 0 1.043.305 1.485.534 1.685.256.224.611.315.966.315.61 0 .97-.207 1.127-.487a1 1 0 111.746.974C10.723 15.653 9.49 16 8.5 16c-.645 0-1.54-.159-2.284-.81C5.447 14.515 5 13.458 5 12c0-1.457.445-2.515 1.216-3.19zM16 8c-.645 0-1.54.159-2.284.81-.77.675-1.216 1.732-1.216 3.19 0 1.457.445 2.515 1.216 3.19.745.651 1.639.81 2.284.81.99 0 2.223-.347 2.873-1.513a1 1 0 10-1.746-.974c-.156.28-.517.487-1.127.487-.355 0-.71-.091-.966-.315-.23-.2-.534-.643-.534-1.685 0-1.043.305-1.485.534-1.685.255-.224.611-.315.966-.315.61 0 .97.207 1.127.487a1 1 0 101.746-.974C18.223 8.347 16.99 8 16 8z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Off: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.354 5.06l.353-.353a1 1 0 00-1.414-1.414l-16 16a1 1 0 101.414 1.414l1.039-1.039A62.067 62.067 0 0012 20c2.256 0 4.37-.141 6.13-.318 2.846-.285 4.87-2.74 4.87-5.6V9.918c0-2.038-1.027-3.87-2.646-4.858zm-1.485 1.485l-1.643 1.643c.64.21 1.252.616 1.647 1.325a1 1 0 11-1.746.974C16.97 10.207 16.61 10 16 10c-.266 0-.532.051-.757.171l-.465.465c-.151.27-.278.692-.278 1.364 0 1.043.305 1.485.534 1.685.255.224.611.315.966.315.61 0 .97-.207 1.127-.487a1 1 0 111.746.974C18.223 15.653 16.99 16 16 16c-.645 0-1.54-.159-2.284-.81-.61-.534-1.017-1.31-1.16-2.332l-1.06 1.06a.995.995 0 01-.123.569c-.431.774-1.12 1.187-1.823 1.377l-1.962 1.962A58.25 58.25 0 0012 18c2.175 0 4.22-.136 5.931-.308C19.657 17.52 21 16.015 21 14.082V9.918c0-1.566-.88-2.85-2.131-3.374zM12 4c1.387 0 2.72.053 3.95.136l-1.903 1.903A55.075 55.075 0 0012 6c-2.175 0-4.22.136-5.931.308C4.343 6.48 3 7.985 3 9.918v4.163c0 .873.273 1.658.732 2.273L2.31 17.777A5.791 5.791 0 011 14.081V9.92c0-2.86 2.024-5.316 4.87-5.601A62.066 62.066 0 0112 4zm-3.5 6c.597 0 .955.198 1.116.47l1.428-1.428C10.358 8.25 9.341 8 8.5 8c-.645 0-1.54.159-2.284.81C5.447 9.485 5 10.542 5 12c0 1.018.217 1.841.611 2.475l1.506-1.506A3.523 3.523 0 017 12c0-1.043.305-1.485.534-1.685.256-.224.611-.315.966-.315z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const DonateIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.627 9.754L14 10l.372-.246C15.88 8.762 18 7.366 18 5.8c0-1.02-.896-1.8-2-1.8-.189 0-.361.026-.52.073-.77.225-1.204.93-1.48 1.427-.277-.498-.71-1.202-1.48-1.427A1.837 1.837 0 0012 4c-1.105 0-2 .78-2 1.8 0 1.566 2.12 2.962 3.627 3.954zM16 2c-.812 0-1.472.232-2 .56A3.731 3.731 0 0012 2c-1.987 0-4 1.466-4 3.8 0 1.796 1.264 3.117 2.119 3.866.799.701 1.755 1.33 2.437 1.778l.334.22a2 2 0 002.22 0l.333-.22c.683-.449 1.639-1.077 2.438-1.778C18.736 8.916 20 7.596 20 5.8 20 3.466 17.986 2 16 2zM2 19.001a1 1 0 00.998 1L5 20.005c.43-.004.761.14.918.209l.062.026 2.403 1.29.066.03c.645.29 1.344.44 2.05.44H16c.71 0 1.398-.112 2.075-.491.537-.3.971-.73 1.274-1.03l.055-.054c.228-.224.537-.567.825-.885l.054-.06c.294-.325.603-.667.903-.985l.075-.078c.317-.333.852-.896 1.164-1.485.185-.348.434-.96.323-1.706-.122-.816-.609-1.388-1.11-1.737-.975-.696-2.081-.566-2.666-.423-.631.155-1.338.487-1.845.993l-.364.362a2.706 2.706 0 00-1.04-.757c-.713-.298-1.452-.272-1.877-.236-.27.022-.648.025-1.243-.105-.701-.153-1.04-.325-1.482-.549l-.206-.104C10.18 12.305 9.374 12 8 12c-1.482 0-2.694.498-4.01 1.04l-.494.202-.76.208a1 1 0 00-.736.964v4.587zm7.268.735l-2.73-1.473A3.004 3.004 0 005.309 18H4V15c.715-.29 2.89-1 4-1 .785 0 1.262.124 1.684.303.18.076.348.162.527.253.432.22.919.467 1.735.668.074.018.15.036.229.053.798.174 1.376.183 1.839.143.569-.048 1.127.018 1.304.43a.78.78 0 01.057.31c0 .306-.11.603-.293.84-.23.298-.576.5-.962.5H13c-.663 0-1.119-.037-1.633-.29A3.329 3.329 0 0111 17a8.376 8.376 0 01-.356-.25c-.454-.33-.89-.646-1.116-.298a.54.54 0 00-.028.048c-.116.225-.038.776.285 1.242.063.09.134.177.215.258l.033.033a7.446 7.446 0 00.183.174l.032.03c.087.078.17.148.252.211.717.554 1.275.554 2.452.552h1.001c.056 0 .112-.002.167-.004a3.457 3.457 0 001.88-.618c.305-.215.54-.461.705-.692.134-.187.222-.364.264-.508A.642.642 0 0017 17l.335-.33 1.153-1.144.051-.05a1.44 1.44 0 01.276-.209c.47-.282 1.227-.468 1.67-.144.63.429.132 1.054-.534 1.767l-.02.021-.007.008-.031.033-.013.014-.132.14-.015.015c-.316.335-.64.693-.93 1.014l-.12.133c-.278.308-.518.57-.682.732-.715.704-1.028 1-2 1h-5.5c-.425 0-.844-.09-1.232-.264z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 3c1.657 0 3 1.3 3 3 0 3.12-2.97 5.132-4.837 6.398-.228.154-.44.297-.627.43a.921.921 0 01-1.072 0 37.607 37.607 0 00-.627-.43C10.97 11.132 8 9.12 8 6c0-1.7 1.343-3 3-3s2.5 1 3 2c.5-1 1.343-2 3-2zM4.567 13.5c.737-.25 1.475-.5 2.567-.5 1.452 0 2.622.537 3.83 1.343.73.486 1.445.964 2.33 1.157.799.174 1.377.182 1.84.143.688-.058 1.223.252 1.223.942S15.5 18 14.501 18h-1.497a4.217 4.217 0 01-2.297-.68 8.988 8.988 0 01-.359-.251c-.503-.364-1.03-.745-1.249-.319-.138.269-.099.79.901 1.75 1.075 1.031 1.57 1.5 3.175 1.5H14.5c2.047 0 3.5-1.5 3.5-3 0-.5-.142-.723-.142-.723.528-.22.947-.619 1.36-1.011.094-.09.187-.18.282-.266.706-.647 1.696-.58 2.243-.181.614.448.44 1.178 0 1.797l-2.93 4.121A3.003 3.003 0 0116.366 22h-4.819c-.424 0-.844-.09-1.231-.264l-3.277-1.472A3.004 3.004 0 005.807 20H3.003a1 1 0 01-1-1L2 15c0-.552.451-.99.998-1.076.591-.093 1.08-.258 1.569-.424z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const PrayIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 14.033c-.012.803-.447 1.262-.993 1.572a3.477 3.477 0 01-.566.253l-1.338-2.006.846-2.536.027-.082.013-.085.79-5.25.002-.015.002-.015A.99.99 0 0110.77 5c.124 0 .224.096.23.217V14.033zM12 3.37A2.22 2.22 0 0010.77 3 2.99 2.99 0 007.8 5.614l-.776 5.152-.864 2.592-1.824 1.216A3 3 0 003 17.07V20a1 1 0 001 1h4.4a1 1 0 00.98-.804l.475-2.37c.32-.096.725-.247 1.138-.481A4.346 4.346 0 0012 16.567c.315.33.668.586 1.007.778.413.234.82.385 1.139.481l.474 2.37a1 1 0 00.98.804H20a1 1 0 001-1v-2.93a3 3 0 00-1.335-2.496l-1.824-1.216-.865-2.592-.775-5.152A2.99 2.99 0 0013.23 3a2.22 2.22 0 00-1.23.37zm1 1.848A.23.23 0 0113.23 5a.99.99 0 01.987.87l.002.014.002.015.79 5.25.013.085.028.082.845 2.536-1.338 2.006a3.476 3.476 0 01-.566-.253c-.546-.31-.981-.77-.993-1.572V5.23v-.013zM7.938 17.21l-1.215-1.823-1.278.851A1 1 0 005 17.07V19h2.58l.358-1.79zm8.124 0l1.216-1.823 1.277.851a1 1 0 01.445.832V19h-2.58l-.358-1.79z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 3.947V15.5a2 2 0 01-2 2l-3-4 1-3 1.195-5.977A1.894 1.894 0 0110.553 3c.523 0 .947.424.947.947zm1 9.822V3.947c0-.523.424-.947.947-.947.903 0 1.68.637 1.858 1.523L16.5 10.5l1 3-3 4a2 2 0 01-2-2v-1.73zm8.5 3.363V20a1 1 0 01-1 1h-3.656a1 1 0 01-.958-.713L15 19l3.5-4.5 1.529.917A2 2 0 0121 17.132zm-18 0V20a1 1 0 001 1h3.656a1 1 0 00.958-.713L9 19l-3.5-4.5-1.529.917A2 2 0 003 17.132z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const TextSizeIcon = {
  Small: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.036 17v1h6.076v-1H11.1c-.607 0-.9-.328-.9-.68V8.1h.4c1.391 0 1.893.688 2.5 2.4h1.15L13.9 7H4.07l-.32 3.5h1.103c.624-1.712 1.135-2.4 2.542-2.4H7.8v8.22c0 .352-.309.68-.916.68h-.848zM16 15.856c0 1.664 1.016 2.336 2.2 2.336 1.072 0 1.86-.592 2.5-1.312l-.54-.704c-.336.288-.658.448-1.01.448-.416 0-.79-.288-.79-.864v-4.24h1.692v-1.232H18.36V8h-1.636l-.144.736c-.176.976-.704 1.764-1.968 1.764H14.5v1.02H16v4.336z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Medium: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.142 17.8V19h7.12v-1.2H11.2c-.78 0-1.2-.36-1.2-.82V6.32h.56c1.76 0 2.502.8 3.262 3.02h1.2L14.662 5H2.722l-.4 4.34h1.22c.8-2.22 1.5-3.02 3.26-3.02h.56v10.66c0 .46-.4.82-1.18.82h-1.04zm11.598-1.26c0 1.96 1.14 2.68 2.44 2.68 1.2 0 2.16-.7 2.94-1.6l-.66-.8c-.44.38-.86.6-1.3.6-.52 0-.94-.36-.94-1.04v-5.56h2.36v-1.4h-2.36V6.54h-1.48l-.18.98c-.2 1.18-.82 2.1-2.34 2.1H15v1.2h1.74v5.72z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Large: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.7 19.728V21h7.968v-1.272H11.42c-.937 0-1.393-.456-1.393-1.008V5.44h.937c2.111 0 2.976.824 3.864 3.56h1.224l-.457-5H1.723l-.471 5H2.5c.936-2.736 1.768-3.56 3.88-3.56h.96v13.28c0 .552-.456 1.008-1.392 1.008H4.7zm12.364-1.49c0 2.208 1.272 3.024 2.712 3.024 1.296 0 2.352-.816 3.264-1.824l-.744-.888c-.528.504-1.032.768-1.584.768-.648 0-1.176-.456-1.176-1.272v-7.048h2.856v-1.5h-2.856V6.19h-1.44l-.192 1.176c-.24 1.368-.96 2.332-2.712 2.332H15v1.3h2.064v7.24z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const ThumbsIcon = {
  Like: {
    Outline: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3 2c-1.224 0-2.258.816-2.634 1.918-.424 1.244-1.121 2.966-1.934 3.942-.744.892-1.358 1.96-1.803 2.843A2.988 2.988 0 006 10H5a3 3 0 00-3 3v5a3 3 0 003 3h1a2.99 2.99 0 002.022-.784l1.416.944a5 5 0 002.773.84H15a7 7 0 007-7v-2.382A3.618 3.618 0 0018.382 9h-1.966l-.004-.002-.004-.003a.308.308 0 01-.085-.113.52.52 0 01-.052-.212.31.31 0 01.03-.15C16.668 7.823 17 6.942 17 6V4.699A2.699 2.699 0 0014.3 2zM7 18v-5a1 1 0 00-1-1H5a1 1 0 00-1 1v5a1 1 0 001 1h1a1 1 0 001-1zm2 0v.465l1.547 1.031a3 3 0 001.664.504H15a5 5 0 005-5v-2.382A1.618 1.618 0 0018.382 11h-1.968c-.926 0-1.577-.606-1.887-1.237-.306-.626-.376-1.453.004-2.175.29-.55.469-1.1.469-1.588V4.699A.699.699 0 0014.3 4c-.31 0-.621.213-.74.564-.423 1.24-1.217 3.287-2.292 4.576-.674.81-1.258 1.851-1.681 2.722A20.678 20.678 0 009 13.187V18z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
    Filled: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.858 3.717C12.054 2.76 12.892 2 13.933 2 15.074 2 16 2.925 16 4.067V6c0 .981-.29 1.917-.603 2.652a.322.322 0 00.095.344c.007.005.008.004.008.004h3.349A3.152 3.152 0 0122 12.151V15a7 7 0 01-7 7h-3.056a5 5 0 01-2.236-.528l-.602-.301A1.998 1.998 0 018 19.384V11.5a1 1 0 01.116-.467c.433-.82 1.481-2.412 2.116-3.173.405-.487.754-1.201 1.038-1.995.278-.78.469-1.567.588-2.148zM5 10a3 3 0 00-3 3v5a3 3 0 003 3 2 2 0 002-2v-7a2 2 0 00-2-2z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
  },
  Dislike: {
    Outline: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7 22c1.224 0 2.258-.816 2.634-1.919.424-1.243 1.121-2.965 1.934-3.94.744-.893 1.358-1.961 1.803-2.844A2.988 2.988 0 0018 14h1a3 3 0 003-3V6a3 3 0 00-3-3h-1a2.99 2.99 0 00-2.022.784l-1.416-.944A5 5 0 0011.79 2H9a7 7 0 00-7 7v2.382A3.618 3.618 0 005.618 15h1.966l.004.002.004.003a.306.306 0 01.085.112c.032.066.05.142.052.213a.31.31 0 01-.03.15C7.332 16.177 7 17.058 7 18v1.301A2.699 2.699 0 009.7 22zM17 6v5a1 1 0 001 1h1a1 1 0 001-1V6a1 1 0 00-1-1h-1a1 1 0 00-1 1zm-2 0v-.465l-1.547-1.031A3 3 0 0011.789 4H9a5 5 0 00-5 5v2.382A1.618 1.618 0 005.618 13h1.968c.926 0 1.577.606 1.887 1.237.306.626.376 1.453-.004 2.175-.29.55-.469 1.1-.469 1.588v1.301c0 .386.313.699.7.699.31 0 .621-.213.74-.564.423-1.24 1.217-3.287 2.292-4.576.674-.81 1.258-1.851 1.681-2.722A20.634 20.634 0 0015 10.813V6z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
    Filled: (props: IconProps) => (
      <IconWrapper {...props}>
        <svg>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.142 20.283c-.196.956-1.034 1.717-2.075 1.717A2.067 2.067 0 018 19.933V18c0-.982.29-1.917.603-2.652a.322.322 0 00-.095-.344C8.5 14.999 8.5 15 8.5 15H5.151A3.152 3.152 0 012 11.849V9a7 7 0 017-7h3.056a5 5 0 012.236.528l.602.301A1.998 1.998 0 0116 4.616V12.5a1 1 0 01-.116.467c-.433.82-1.481 2.412-2.116 3.173-.405.486-.754 1.201-1.038 1.995-.278.78-.469 1.567-.588 2.148zM19 14a3 3 0 003-3V6a3 3 0 00-3-3 2 2 0 00-2 2v7a2 2 0 002 2z"
            fill={props.fill}
          />
        </svg>
      </IconWrapper>
    ),
  },
};

export const PaymentIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        d="M6 15.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM11.5 15a.5.5 0 000 1h2a.5.5 0 000-1h-2z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.554 4c-.238 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 00-1.311 1.311A3.016 3.016 0 002.02 6.78C2 7.031 2 7.315 2 7.554v8.892c0 .238 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 001.311 1.311c.436.222.852.283 1.142.307.251.02.536.02.774.02h12.892c.238 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 001.311-1.311c.222-.436.283-.852.307-1.142.02-.251.02-.535.02-.774V7.554c0-.239 0-.523-.02-.774a3.017 3.017 0 00-.307-1.142 3 3 0 00-1.311-1.311 3.016 3.016 0 00-1.142-.307C18.969 4 18.685 4 18.446 4H5.554zM4 7.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C4.76 6 5.04 6 5.6 6h12.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C20 6.76 20 7.04 20 7.6V8H4v-.4zM4 11v5.4c0 .56 0 .84.109 1.054a1 1 0 00.437.437C4.76 18 5.04 18 5.6 18h12.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C20 17.24 20 16.96 20 16.4V11H4z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const AccountIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-6.03 6.947A7.964 7.964 0 0112 20c-1.445 0-2.8-.383-3.97-1.053a7.68 7.68 0 01.537-.86C9.536 16.747 10.768 16 12 16c1.232 0 2.464.748 3.433 2.086.194.27.374.557.538.86zm1.612-1.216a9.604 9.604 0 00-.53-.817c-.554-.766-1.228-1.445-1.998-1.955a5 5 0 10-6.107 0c-.77.51-1.445 1.189-2 1.955-.188.26-.365.533-.53.817a8 8 0 1111.164 0zM9 11a3 3 0 116 0 3 3 0 01-6 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const LanguageIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.407 5.741C6.093 6.762 4.459 8.734 4.082 11h2.949c.124-2.034.626-3.864 1.376-5.259zM12 3C6.591 3 2 6.922 2 12c0 5.078 4.591 9 10 9 1.669 0 3.248-.368 4.638-1.023C17.727 20.534 19.183 21 21 21a1 1 0 00.625-1.78c-.692-.554-1.113-1.328-1.36-2.15C21.354 15.634 22 13.889 22 12c0-5.078-4.591-9-10-9zm0 2c-.325 0-1.039.26-1.787 1.607C9.612 7.69 9.16 9.217 9.035 11h5.93c-.125-1.783-.577-3.31-1.178-4.393C13.04 5.26 12.325 5 12 5zm4.97 6c-.125-2.034-.627-3.864-1.377-5.259 2.314 1.021 3.948 2.993 4.325 5.259H16.97zm-2.005 2h-5.93c.125 1.783.577 3.31 1.178 4.393C10.96 18.74 11.675 19 12 19c.325 0 1.039-.26 1.787-1.607.601-1.082 1.053-2.61 1.178-4.393zm.63 5.254c.75-1.394 1.25-3.222 1.374-5.254h2.95c-.193 1.176-.72 2.264-1.508 3.185a1 1 0 00-.216.868c.116.518.29 1.075.548 1.623a7.106 7.106 0 01-1.575-.69 1 1 0 00-.984-.02c-.19.103-.387.199-.588.288zm-7.188.005c-.75-1.395-1.252-3.225-1.376-5.259H4.082c.377 2.267 2.01 4.238 4.325 5.259z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SupportIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.298 8.295a5.002 5.002 0 019.404 0A3 3 0 0015 11v2a3 3 0 001.895 2.79 3.005 3.005 0 01-2.21 2.132A1.999 1.999 0 0011 19a2 2 0 003.765.942 5.004 5.004 0 004.162-4.088A3.001 3.001 0 0021 13v-2c0-1.403-.963-2.58-2.263-2.909a7.003 7.003 0 00-13.474 0A3.001 3.001 0 003 11v2a3 3 0 106 0v-2a3 3 0 00-1.702-2.705zM6 10a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm12 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const LegalIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.447 3.106a1 1 0 00-.894 0l-8 4A1 1 0 003 8v2a1 1 0 001 1h1v5H4a1 1 0 00-1 1v3a1 1 0 001 1h16a1 1 0 001-1v-3a1 1 0 00-1-1h-1v-5h1a1 1 0 001-1V8a1 1 0 00-.553-.894l-8-4zM19 9v-.382l-7-3.5-7 3.5V9h14zm-6 2h-2v5h2v-5zm2 5v-5h2v5h-2zm-8-5h2v5H7v-5zm-2 8v-1h14v1H5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ProfileIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.054 11.96a5 5 0 10-6.108 0c-.77.509-1.444 1.188-1.999 1.954C5.738 15.584 5 17.79 5 20a1 1 0 001 1h12a1 1 0 001-1c0-2.21-.738-4.416-1.947-6.086-.555-.766-1.23-1.445-2-1.955zM9 8a3 3 0 116 0 3 3 0 01-6 0zm3 5c-1.232 0-2.464.748-3.433 2.086-.782 1.082-1.329 2.47-1.505 3.914h9.876c-.176-1.444-.723-2.832-1.505-3.914C14.464 13.748 13.232 13 12 13z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const PasswordIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path d="M8 17a1 1 0 100-2 1 1 0 000 2z" fill={props.fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 3a2 2 0 00-1.414.586l-5.51 5.51a6 6 0 104.922 5.734l.416-.416A2 2 0 0016 13a2 2 0 001.95-1.55A2 2 0 0019.5 9.5v-.172l.914-.914A2 2 0 0021 7V5a2 2 0 00-2-2h-2zm-8 8c.587 0 1.144.126 1.646.354L17 5h2v2l-1.5 1.5v1h-1l-.5.5v1h-1l-1 1v1l-1.101 1.101A4 4 0 119 11z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const TrackingIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.5A3.5 3.5 0 017.5 6H15a1 1 0 110 2H7.5a1.5 1.5 0 100 3h9a3.5 3.5 0 110 7H9a1 1 0 110-2h7.5a1.5 1.5 0 000-3h-9A3.5 3.5 0 014 9.5z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 6a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0zM7 16a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const PhoneIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3a1 1 0 00-1 1v3H4a1 1 0 100 2h3v6H4a1 1 0 100 2h3v3a1 1 0 102 0v-3h6v3a1 1 0 102 0v-3h3a1 1 0 100-2h-3V9h3a1 1 0 100-2h-3V4a1 1 0 10-2 0v3H9V4a1 1 0 00-1-1zm7 6H9v6h6V9z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const EmailIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        d="M12.12 21C6.788 21 3 17.24 3 12c0-5.299 3.849-9 9.4-9 5.112 0 8.6 3.292 8.6 8.104 0 3.429-1.604 5.65-4.09 5.65-1.222 0-2.184-.546-2.485-1.384h-.12c-.561.857-1.603 1.383-2.766 1.383-2.365 0-3.909-1.87-3.909-4.675 0-2.786 1.564-4.656 3.869-4.656 1.022 0 1.964.468 2.365 1.169h.12l.04-.994h1.885v5.825c0 .935.42 1.48 1.142 1.48 1.103 0 1.724-1.285 1.724-3.545 0-3.857-2.546-6.448-6.394-6.448-4.23 0-7.156 2.922-7.156 7.091 0 4.15 2.906 7.09 7.016 7.09 1.172 0 2.322-.23 3.28-.615.501-.202 1.102-.04 1.358.436.242.449.088 1.013-.378 1.22-1.262.558-2.795.869-4.38.869zm-.36-6.117c1.162 0 1.944-1.11 1.944-2.825 0-1.675-.762-2.746-1.925-2.746-1.142 0-1.864 1.052-1.864 2.766s.722 2.805 1.845 2.805z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SubscriptionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19c-1.425 0-2.394-.001-3.147-.052-.735-.05-1.117-.142-1.384-.253a4 4 0 01-2.165-2.164c-.11-.267-.201-.65-.252-1.384C5.002 14.394 5 13.425 5 12c0-1.425.001-2.394.052-3.147.05-.735.142-1.117.252-1.384A4 4 0 017.47 5.304c.267-.11.65-.201 1.384-.252C9.606 5.002 10.575 5 12 5c1.425 0 2.394.001 3.147.052.735.05 1.117.142 1.384.252a4 4 0 012.165 2.165c.11.267.201.65.252 1.384.05.753.052 1.722.052 3.147 0 1.425-.001 2.394-.052 3.147-.05.735-.142 1.117-.253 1.384a4 4 0 01-2.164 2.165c-.267.11-.65.201-1.384.252-.753.05-1.722.052-3.147.052zm-9-7c0-2.796 0-4.193.457-5.296a6 6 0 013.247-3.247C7.807 3 9.204 3 12 3c2.796 0 4.194 0 5.296.457a6 6 0 013.247 3.247C21 7.807 21 9.204 21 12c0 2.796 0 4.194-.457 5.296a6 6 0 01-3.247 3.247C16.194 21 14.796 21 12 21c-2.796 0-4.193 0-5.296-.457a6 6 0 01-3.247-3.247C3 16.194 3 14.796 3 12zm9.53-4.612a.556.556 0 00-1.06 0l-.72 2.276a1.667 1.667 0 01-1.086 1.086l-2.276.72a.556.556 0 000 1.06l2.276.72c.517.164.922.569 1.086 1.086l.72 2.276a.556.556 0 001.06 0l.72-2.276a1.667 1.667 0 011.086-1.086l2.276-.72a.556.556 0 000-1.06l-2.276-.72a1.667 1.667 0 01-1.086-1.086l-.72-2.276z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

SubscriptionIcon.Outline = SubscriptionIcon;

SubscriptionIcon.Filled = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.457 6.704C3 7.807 3 9.204 3 12c0 2.796 0 4.194.457 5.296a6 6 0 003.247 3.247C7.807 21 9.204 21 12 21c2.796 0 4.194 0 5.296-.457a6 6 0 003.247-3.247C21 16.194 21 14.796 21 12c0-2.796 0-4.193-.457-5.296a6 6 0 00-3.247-3.247C16.194 3 14.796 3 12 3c-2.796 0-4.193 0-5.296.457a6 6 0 00-3.247 3.247zM12 6.913c.246 0 .464.16.539.395l.733 2.315c.166.527.579.939 1.105 1.105l2.315.733a.565.565 0 010 1.078l-2.315.733a1.695 1.695 0 00-1.105 1.105l-.733 2.315a.565.565 0 01-1.078 0l-.733-2.315a1.695 1.695 0 00-1.105-1.105l-2.315-.733a.565.565 0 010-1.078l2.315-.733a1.695 1.695 0 001.105-1.105l.733-2.315A.565.565 0 0112 6.913z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

SubscriptionIcon.Small = (props: IconProps) => (
  <IconWrapper {...props} size={12} viewBox="0 0 12 12">
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0a4 4 0 00-4 4v4a4 4 0 004 4h4a4 4 0 004-4V4a4 4 0 00-4-4H4zm2.424 2.31a.444.444 0 00-.848 0L5 4.131A1.333 1.333 0 014.131 5l-1.82.576a.444.444 0 000 .848L4.13 7c.414.131.738.455.869.869l.576 1.82a.444.444 0 00.848 0L7 7.87c.131-.414.455-.738.869-.869l1.82-.576a.444.444 0 000-.848L7.87 5A1.333 1.333 0 017 4.131l-.576-1.82z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const FilterIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm2 4a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1zm3 3a1 1 0 100 2h4a1 1 0 100-2h-4z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

FilterIcon.Off = FilterIcon;

FilterIcon.On = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 11a3 3 0 100-6 3 3 0 000 6zM6 7h6.1a5.022 5.022 0 000 2H6a1 1 0 010-2zm7 4a4.997 4.997 0 003.306 1.952A1 1 0 0116 13H8a1 1 0 110-2h5zm-3 4a1 1 0 100 2h4a1 1 0 100-2h-4z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const PinIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.803 9.584a1.908 1.908 0 011.271.079c.217.092.42.227.596.403l.072.072 3.793-3.793v-.81a.25.25 0 01.426-.177l2.682 2.682a.25.25 0 01-.176.427h-.811l-3.774 3.811.053.053a1.893 1.893 0 01.482 1.867 1.89 1.89 0 01-.482.818.237.237 0 01-.336 0l-4.614-4.614a.237.237 0 010-.335 1.89 1.89 0 01.818-.483zm-2.232-.932a3.898 3.898 0 013.822-.994l2.142-2.141c.014-1.993 2.428-2.987 3.84-1.573l2.683 2.682c1.412 1.411.421 3.821-1.568 3.84l-2.14 2.163a3.898 3.898 0 01-1.001 3.801 2.237 2.237 0 01-3.164 0l-1.343-1.342-6.944 5.786a.548.548 0 01-.771-.77l5.787-6.945-1.343-1.343a2.237 2.237 0 010-3.164z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.534 4.253v1.103l-3.249 3.249a3.502 3.502 0 00-4.14.605l-.203.203a1.348 1.348 0 000 1.907l1.971 1.971-5.786 6.944a.547.547 0 00.77.772l6.945-5.787 1.971 1.971c.527.527 1.38.527 1.907 0l.203-.203a3.501 3.501 0 00.605-4.14l3.249-3.25h1.104c1.113 0 1.67-1.346.883-2.133l-4.096-4.096c-.787-.788-2.134-.23-2.134.884z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const TrashIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9,5c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v1H9V5z M7,6V5c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v1h4c0.6,0,1,0.4,1,1
        s-0.4,1-1,1h-1.1l-1.6,11.4c-0.2,1.5-1.5,2.6-3,2.6H8.7c-1.5,0-2.8-1.1-3-2.6L4.1,8H3C2.4,8,2,7.6,2,7s0.4-1,1-1H7z M6.2,8h11.7
        l-1.6,11.1c-0.1,0.5-0.5,0.9-1,0.9H8.7c-0.5,0-0.9-0.4-1-0.9L6.2,8z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MusicIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4a1 1 0 00-2 0v7c0 .662-.269 1.11-.727 1.43-.5.346-1.278.57-2.273.57-1.657 0-2.928.415-3.794 1.194C4.33 14.982 4 16.025 4 17c0 .975.33 2.018 1.206 2.806C6.072 20.585 7.343 21 9 21c1.74 0 3.045-.592 3.893-1.61C13.715 18.404 14 17.15 14 16V8.659c.128.115.261.224.4.329 1.52 1.14 3.587 1.546 5.842.982a1 1 0 10-.485-1.94c-1.744.436-3.177.093-4.157-.642C14.618 6.65 14 5.455 14 4zM9 15c1.077 0 2.13-.204 3-.674V16c0 .851-.215 1.596-.643 2.11-.402.482-1.098.89-2.357.89-1.343 0-2.072-.335-2.456-.68C6.17 17.981 6 17.524 6 17s.17-.982.544-1.32C6.928 15.336 7.657 15 9 15z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const AudioIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6a1 1 0 011 1v10a1 1 0 11-2 0V7a1 1 0 011-1zm-4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm8 1.571a1 1 0 011 1v2.858a1 1 0 11-2 0V10.57a1 1 0 011-1zM4 10a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z"
        fill={props.fill}
      />
      <path
        d="M8 6a1 1 0 011 1v10a1 1 0 11-2 0V7a1 1 0 011-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const AudioControlsIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5a1 1 0 012 0v3h1a1 1 0 010 2H4a1 1 0 010-2h1V5zm0 14a1 1 0 102 0v-7H5v7zm7-15a1 1 0 00-1 1v7h2V5a1 1 0 00-1-1zm-1 15a1 1 0 102 0v-3h1a1 1 0 100-2h-4a1 1 0 100 2h1v3zm7-15a1 1 0 00-1 1v3h-1a1 1 0 100 2h4a1 1 0 100-2h-1V5a1 1 0 00-1-1zm-1 15a1 1 0 102 0v-7h-2v7z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ModeIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8.002 8.002 0 01-7.002 7.938C12.45 20.007 12 19.552 12 19V5c0-.552.45-1.007.998-.938A8.001 8.001 0 0120 12z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ColorIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 018-8c4.296 0 8 3.228 8 7.667A3.333 3.333 0 0116.667 15H13.65a2.151 2.151 0 00-1.79 3.345l.55.823c.228.344-.024.832-.446.832h-.215C7.33 20 4 16.314 4 12zm8-10C6.477 2 2 6.477 2 12c0 5.52 4.462 10 9.965 10a2.535 2.535 0 002.11-3.942l-.55-.823c-.063-.094.013-.235.126-.235h3.016A5.333 5.333 0 0022 11.667C22 6.137 17.388 2 12 2zM9.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-3 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const QuoteIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 9.004C8.5 9 7.5 10.5 7.5 12H10c.552 0 1 .442 1 .995V17A1 1 0 0110 18H5a1 1 0 01-1-1v-3.505C4 8.662 6.5 6 9.5 6.002c.275-.014.5.212.5.488V8.49a.525.525 0 01-.5.513zm9 0c-1 0-2 1.496-2 2.996H19c.552 0 1 .442 1 .995V17A1 1 0 0119 18h-5a1 1 0 01-1-1v-3.505C13 8.662 15.5 6 18.5 6.002c.275-.014.5.212.5.488V8.49a.525.525 0 01-.5.513z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const PlaceholderIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <circle cx="12" cy="12" r="5" fill={props.fill} />
    </svg>
  </IconWrapper>
);

export const ShareIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.707 4.293a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414L11 7.414V13a1 1 0 102 0V7.414l2.293 2.293a1 1 0 001.414-1.414l-4-4zM6 13a1 1 0 10-2 0v3a5 5 0 005 5h6a5 5 0 005-5v-3a1 1 0 10-2 0v3a3 3 0 01-3 3H9a3 3 0 01-3-3v-3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Share2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.086 5.595A1 1 0 015 5h14a1 1 0 01.88 1.474l-7 13a1 1 0 01-1.846-.216l-1.938-7.265-4.836-5.32a1 1 0 01-.174-1.078zm7.073 6.369l1.157 4.34 4.05-7.523-5.207 3.183zM15.446 7H7.26l2.923 3.216L15.446 7z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const LinkIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.757 5c-.86 0-1.684.342-2.293.95L10.95 8.464a3.243 3.243 0 001.428 5.42c-.087.219-.218.42-.388.59l-1.012 1.013A5.243 5.243 0 019.536 7.05l2.514-2.514a5.242 5.242 0 117.415 7.414l-2.002 2.002a6.737 6.737 0 00-.232-2.598l.82-.818A3.243 3.243 0 0015.756 5zM6.5 10.757c0 .655.094 1.29.269 1.889l-.82.818a3.243 3.243 0 004.587 4.586l2.514-2.514a3.243 3.243 0 00-1.428-5.42c.087-.219.218-.42.388-.59l1.012-1.013a5.243 5.243 0 011.442 8.437l-2.514 2.515a5.242 5.242 0 11-7.414-7.415l2.001-2.002a6.746 6.746 0 00-.037.71z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MailIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 4H6a4 4 0 00-4 4v8a4 4 0 004 4h12a4 4 0 004-4V8a4 4 0 00-4-4zM5.571 6.046C5.71 6.016 5.853 6 6 6h12c.147 0 .29.016.429.046L12 11.671 5.571 6.046zM4.09 7.406A2 2 0 004 8v8a2 2 0 002 2h12a2 2 0 002-2V8c0-.206-.031-.406-.09-.593l-6.593 5.77a2 2 0 01-2.634 0l-6.594-5.77z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ReportIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        d="M11 7a1 1 0 112 0v4a1 1 0 11-2 0V7zM12 15a1 1 0 100-2 1 1 0 000 2z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 011.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v4.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 01-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H15.5l-2.7 3.6a1 1 0 01-1.6 0L8.5 18h-.741c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 01-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 13.71 2 13.046 2 12.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 011.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2zM5.91 4.038c-.438.035-.663.1-.819.18a2 2 0 00-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8v4.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 00.874.874c.156.08.38.145.819.18C6.361 16 6.943 16 7.8 16H9a1 1 0 01.8.4l2.2 2.933 2.2-2.933a1 1 0 01.8-.4h1.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 00.874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 00-.874-.874c-.156-.08-.38-.145-.819-.18C17.639 4 17.057 4 16.2 4H7.8c-.857 0-1.439 0-1.889.038z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const RadioIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.343 6.343a8 8 0 000 11.314A1 1 0 114.93 19.07c-3.905-3.905-3.905-10.237 0-14.142a1 1 0 011.414 1.414zM17.657 4.93a1 1 0 011.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 01-1.414-1.414 8 8 0 000-11.314 1 1 0 010-1.414zM14 12a2 2 0 11-4 0 2 2 0 014 0zm2.243-4.243a1 1 0 10-1.415 1.415 4 4 0 010 5.656 1 1 0 001.415 1.415 6 6 0 000-8.486zM9.172 9.172a1 1 0 00-1.415-1.415 6 6 0 000 8.486 1 1 0 001.415-1.414 4 4 0 010-5.657z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const VideoIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-.132l2.89 1.928c1.33.886 3.11-.067 3.11-1.665V7.87c0-1.598-1.78-2.55-3.11-1.665L16 8.131V8a3 3 0 00-3-3H5zm11 5.535v2.93l4 2.666V7.87l-4 2.666zM14 10V8a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1v-6z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props} viewBox={"0 0 12 12"}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 2C0.671573 2 0 2.67157 0 3.5V8.5C0 9.32843 0.671573 10 1.5 10H6.5C7.32843 10 8 9.32843 8 8.5V8L10.5528 9.27639C11.2177 9.60884 12 9.12535 12 8.38197V3.61803C12 2.87465 11.2177 2.39116 10.5528 2.72361L8 4V3.5C8 2.67157 7.32843 2 6.5 2H1.5Z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const MarkUnplayedIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c-.667 0-1.319.065-1.95.19a1 1 0 10.388 1.962 8.044 8.044 0 013.124 0 1 1 0 10.389-1.962A10.043 10.043 0 0012 2zm5.557 1.685a1 1 0 00-1.113 1.662 8.048 8.048 0 012.21 2.209 1 1 0 001.661-1.113 10.05 10.05 0 00-2.758-2.758zM7.556 5.347a1 1 0 00-1.113-1.662 10.05 10.05 0 00-2.758 2.758 1 1 0 001.662 1.113 8.05 8.05 0 012.209-2.21zm-3.404 5.09a1 1 0 10-1.962-.387 10.043 10.043 0 000 3.9 1 1 0 101.962-.388 8.044 8.044 0 010-3.124zm17.658-.387a1 1 0 00-1.962.388 8.044 8.044 0 010 3.124 1 1 0 101.962.389 10.048 10.048 0 000-3.902zm-1.495 7.507a1 1 0 00-1.662-1.113 8.046 8.046 0 01-2.209 2.21 1 1 0 001.113 1.661 10.052 10.052 0 002.758-2.758zM5.347 16.444a1 1 0 10-1.662 1.113 10.05 10.05 0 002.758 2.758 1 1 0 001.113-1.662 8.048 8.048 0 01-2.21-2.209zm5.09 3.404a1 1 0 10-.387 1.962 10.048 10.048 0 003.9 0 1 1 0 00-.388-1.962 8.044 8.044 0 01-3.124 0zm6.27-9.14a1 1 0 00-1.414-1.415L11 13.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l5-5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MembersIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.167a3.167 3.167 0 016.232-.8 5.16 5.16 0 00-2.055 3.802A3.167 3.167 0 016 7.167zm4.444 5.007a5.173 5.173 0 01-4.38-.876 5.669 5.669 0 00-3.043 4.545c.183.11.448.25.809.395.842.337 2.223.703 4.316.756a7.69 7.69 0 012.866-3.66 5.145 5.145 0 01-.568-1.16zM4.703 9.77a5.167 5.167 0 119.353-4.277 5.167 5.167 0 015.599 7.84A7.658 7.658 0 0123 19.667a1 1 0 01-.293.707c-.187.187 0 0 0 0l-.002.002a2.035 2.035 0 01-.15.134c-.081.067-.193.152-.339.25a7.106 7.106 0 01-1.303.668c-1.172.47-2.967.905-5.58.905-2.612 0-4.407-.435-5.58-.904a7.107 7.107 0 01-1.302-.67 4.174 4.174 0 01-.437-.334 1.622 1.622 0 01-.052-.05H7.96c-.002-.002.075.07-.001-.001a1 1 0 01-.293-.707c0-.232.01-.461.03-.688-2.095-.092-3.589-.475-4.61-.884a7.107 7.107 0 01-1.303-.67 3.238 3.238 0 01-.49-.384c-.002 0 .107.099-.001 0A1 1 0 011 16.333 7.662 7.662 0 014.703 9.77zm10.63-2.437a3.167 3.167 0 100 6.334 3.167 3.167 0 000-6.334zm0 8.334c1.068 0 2.06-.324 2.884-.88a5.667 5.667 0 012.762 4.39c-.183.11-.448.25-.809.395-.91.364-2.45.761-4.837.761-2.387 0-3.926-.397-4.837-.761a5.502 5.502 0 01-.808-.396 5.667 5.667 0 012.761-4.388c.824.555 1.816.879 2.884.879z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MembersAddIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5a3 3 0 100 6 3 3 0 000-6zm5 3a4.99 4.99 0 01-1.75 3.8A7 7 0 0119 18a1 1 0 11-2 0 5 5 0 00-10 0 1 1 0 11-2 0 7 7 0 013.75-6.2A5 5 0 1117 8zm-4 8a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1v-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ContactsIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3a6 6 0 00-6 6v6a6 6 0 006 6h6a6 6 0 006-6V9a6 6 0 00-6-6H9zM5 9a4 4 0 014-4h6a4 4 0 014 4v6a4 4 0 01-4 4H9a4 4 0 01-4-4V9zm7 0a1.286 1.286 0 00-.014 2.571h.028A1.286 1.286 0 0012 9zm-3.286 1.286c0 .568.145 1.103.399 1.57-1.259.83-2.113 2.2-2.113 3.801a1 1 0 00.375.781c.267.213.814.475 1.219.619.755.268 1.869.514 3.406.514 1.537 0 2.651-.246 3.406-.515.377-.134.662-.272.862-.385a3.418 3.418 0 00.356-.232l-.033.024.034-.025a1 1 0 00.375-.78c0-1.601-.854-2.972-2.113-3.803a3.286 3.286 0 10-6.173-1.57zm.354 4.811c.189-.772.763-1.448 1.584-1.814.411.185.868.288 1.348.288.48 0 .937-.103 1.348-.288.821.366 1.395 1.042 1.584 1.814a4.43 4.43 0 01-.196.075c-.53.189-1.416.4-2.736.4-1.32 0-2.206-.211-2.736-.4a4.5 4.5 0 01-.196-.075z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SmileIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.243 13.914a1 1 0 10-1.415-1.414 4 4 0 01-5.656 0 1 1 0 00-1.415 1.414 6 6 0 008.486 0zm-6.95-4.5a1.121 1.121 0 00-1.586 0A1 1 0 016.293 10a3.121 3.121 0 014.414 0 1 1 0 01-1.414 1.414zm5.414 0a1.121 1.121 0 011.586 0A1 1 0 0017.707 10a3.121 3.121 0 00-4.414 0 1 1 0 001.414 1.414z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Feedback2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5a3 3 0 013 3v13l-2-2H8a3 3 0 01-3-3V8a3 3 0 013-3h8zm1.586 17.414L16.172 21H8a5 5 0 01-5-5V8a5 5 0 015-5h8a5 5 0 015 5v13a2 2 0 01-3.414 1.414zm-2.05-7.878a1 1 0 10-1.415-1.415 3 3 0 01-4.242 0 1 1 0 00-1.415 1.415 5 5 0 007.072 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const RoutinesIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        d="M15 9.5a5.5 5.5 0 01-8.657 4.504A6.002 6.002 0 0018 12a6.002 6.002 0 00-3.996-5.657c.628.893.996 1.982.996 3.157z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1116 0 8 8 0 01-16 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const CalendarIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5h4c1.433 0 2.388.002 3.121.061.71.058 1.035.161 1.241.266a3 3 0 011.311 1.311c.105.206.208.53.266 1.24l.009.122H4.052l.01-.121c.057-.71.16-1.035.265-1.241a3 3 0 011.311-1.311c.206-.105.53-.208 1.24-.266C7.613 5.001 8.568 5 10 5zm-5.999 5L4 11v3c0 1.433.002 2.388.061 3.121.058.71.161 1.035.266 1.241a3 3 0 001.311 1.311c.206.105.53.208 1.24.266.734.06 1.689.061 3.122.061h4c1.433 0 2.388-.002 3.121-.061.71-.058 1.035-.161 1.241-.266a3 3 0 001.311-1.311c.105-.206.208-.53.266-1.24.06-.734.061-1.689.061-3.122v-3l-.001-1H4zM2 11c0-2.8 0-4.2.545-5.27A5 5 0 014.73 3.545C5.8 3 7.2 3 10 3h4c2.8 0 4.2 0 5.27.545a5 5 0 012.185 2.185C22 6.8 22 8.2 22 11v3c0 2.8 0 4.2-.545 5.27a5 5 0 01-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 01-2.185-2.185C2 18.2 2 16.8 2 14v-3zm11 2a1 1 0 112 0 1 1 0 01-2 0zm4-1a1 1 0 100 2 1 1 0 000-2zm-7 1a1 1 0 112 0 1 1 0 01-2 0zm3 3a1 1 0 100 2 1 1 0 000-2zm-4 1a1 1 0 112 0 1 1 0 01-2 0zm-2-1a1 1 0 100 2 1 1 0 000-2z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ShoppingBagIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.625c0-.472.024-.818.2-1.075.121-.177.49-.55 1.8-.55s1.68.373 1.8.55c.176.257.2.603.2 1.075V7h-4V5.625zM8 9v1a1 1 0 102 0V9h4v1a1 1 0 102 0V9h2v9a2 2 0 01-2 2H8a2 2 0 01-2-2V9h2zm0-2V5.579c0-.427-.003-1.354.55-2.16C9.18 2.502 10.31 2 12 2c1.69 0 2.821.502 3.45 1.419.553.806.55 1.733.55 2.16V7h3a1 1 0 011 1v10a4 4 0 01-4 4H8a4 4 0 01-4-4V8a1 1 0 011-1h3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const EmptyIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 0112.906-6.32L5.68 16.906A7.965 7.965 0 014 12zm3.094 6.32A8 8 0 0018.32 7.094L7.094 18.32zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Cross1Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5a1 1 0 10-2 0v4H7a1 1 0 000 2h4v8a1 1 0 102 0v-8h4a1 1 0 100-2h-4V5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Cross2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4.447c0 .339.191.649.494.8L10 5.5c.613.306 1 .933 1 1.618V11H7.118A1.809 1.809 0 015.5 10l-.253-.506a.894.894 0 00-.8-.494C4.2 9 4 9.2 4 9.447v5.106c0 .247.2.447.447.447a.894.894 0 00.8-.494L5.5 14c.306-.613.933-1 1.618-1H11v3.882c0 .685-.387 1.312-1 1.618l-.506.253a.894.894 0 00-.494.8c0 .247.2.447.447.447h5.106c.247 0 .447-.2.447-.447a.894.894 0 00-.494-.8L14 18.5c-.613-.306-1-.933-1-1.618V13h3.882c.685 0 1.312.387 1.618 1l.253.506a.894.894 0 00.8.494c.247 0 .447-.2.447-.447V9.447C20 9.2 19.8 9 19.553 9a.894.894 0 00-.8.494L18.5 10c-.306.613-.933 1-1.618 1H13V7.118c0-.685.387-1.312 1-1.618l.506-.253a.894.894 0 00.494-.8C15 4.2 14.8 4 14.553 4H9.447C9.2 4 9 4.2 9 4.447z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MergeIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 20a1 1 0 102 0v-2.757a2 2 0 01.586-1.415L12 12.414l3.414 3.414A2 2 0 0116 17.243V20a1 1 0 102 0v-2.757a4 4 0 00-1.172-2.829L13 10.586V8h1a1 1 0 00.832-1.555l-2-3a1 1 0 00-1.664 0l-2 3A1 1 0 0010 8h1v2.586l-3.828 3.828A4 4 0 006 17.243V20z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Globe1Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.747 18.177C12.948 19.774 12.215 20 12 20c-.215 0-.948-.226-1.747-1.823-.639-1.278-1.11-3.083-1.226-5.177h5.946c-.116 2.094-.587 3.899-1.226 5.177zM14.973 11H9.027c.116-2.094.587-3.899 1.226-5.177C11.052 4.226 11.785 4 12 4c.215 0 .948.226 1.747 1.823.639 1.278 1.11 3.083 1.226 5.177zm2.002 2c-.12 2.434-.678 4.61-1.512 6.214A8.007 8.007 0 0019.938 13h-2.963zm2.963-2a8.007 8.007 0 00-4.475-6.214c.834 1.603 1.392 3.78 1.512 6.214h2.963zM7.025 11c.12-2.434.678-4.61 1.512-6.214A8.007 8.007 0 004.062 11h2.963zm-2.963 2a8.007 8.007 0 004.475 6.214C7.703 17.61 7.145 15.434 7.025 13H4.062zM22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Globe2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.925 16.008A8 8 0 014.66 8.811a.635.635 0 01.325.174l.974.974a.799.799 0 01.074.086l.938 1.25c.144.193.188.44.153.678-.132.88.137 1.36.367 1.554l.075.06c.043.033.086.066.125.104l.874.874a.8.8 0 01.234.566V17.375a.8.8 0 00.994.776l.18-.045a.8.8 0 00.565-.523l.261-.784.346-1.384a.8.8 0 01.21-.372l.81-.81a.8.8 0 00.234-.565V13.2a.8.8 0 00-.32-.64l-1.067-.8a.8.8 0 00-.48-.16H9.39a.8.8 0 01-.358-.085l-.393-.196a.8.8 0 01-.357-.358l-.453-.906a.8.8 0 01.088-.855l.279-.352a.8.8 0 01.533-.298l1.034-.122a.8.8 0 01.452.078l.502.251a.4.4 0 00.52-.563l-.515-.859a.8.8 0 01.12-.977l.267-.267a.798.798 0 00.15-.208l.194-.387a.8.8 0 00.043-.61l-.282-.848a7.965 7.965 0 015.671 1.625.807.807 0 00-.104.185l-.288.72a.8.8 0 01-.299.37l-.637.424a.8.8 0 00-.356.666v.277a.8.8 0 00.442.716l.061.03a.8.8 0 00.611.044l2.086-.696.616-.246c.275.5.498 1.033.662 1.59l-1.04.209a.8.8 0 00-.41.219l-.572.572a.795.795 0 00-.1.122l-.442.663a.8.8 0 00.025.924l.827 1.102c.022.03.047.059.074.086l.526.525a.8.8 0 01.234.566v.77c0 .065.008.13.024.194l.033.134c.016.064.04.124.068.18zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const TimeIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
        fill={props.fill}
      />
      <path
        d="M11.998 7a1 1 0 011 1v3.585l1.712 1.705c.39.39.39 1.03 0 1.42-.39.39-1.03.39-1.42 0l-2-2.003-.292-.293V8a1 1 0 011-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const RecentlyPlayedIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.011 11.575a8 8 0 112.33 6.079 1 1 0 10-1.416 1.413A9.972 9.972 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2c-5.387 0-9.779 4.26-9.992 9.594l-.3-.301a1 1 0 00-1.415 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 10-1.414-1.414l-.282.282zM11.998 7a1 1 0 011 1v3.585l1.712 1.705c.39.39.39 1.03 0 1.42-.39.39-1.03.39-1.42 0l-2-2.003-.292-.293V8a1 1 0 011-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const CopyIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3a3 3 0 00-3 3v1H7a3 3 0 00-3 3v8a3 3 0 003 3h5a3 3 0 003-3v-1h2a3 3 0 003-3V7.828a3 3 0 00-.879-2.12l-1.828-1.83A3 3 0 0015.172 3H12zm3 12h2a1 1 0 001-1V7.828a1 1 0 00-.293-.707L15.88 5.293A1 1 0 0015.172 5H12a1 1 0 00-1 1v1.117a3 3 0 011.293.762l1.828 1.828A3 3 0 0115 11.828V15zm-9-5a1 1 0 011-1h3.172a1 1 0 01.707.293l1.828 1.828a1 1 0 01.293.707V18a1 1 0 01-1 1H7a1 1 0 01-1-1v-8z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const InfoIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.5-13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11.92 11a1 1 0 00-.996.917l-.334 4A1 1 0 0011.587 17h.826a1 1 0 00.997-1.083l-.334-4A1 1 0 0012.08 11h-.16z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const NoticeIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.5-6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm1.58-2.5a1 1 0 00.996-.917l.334-4A1 1 0 0012.413 7h-.826a1 1 0 00-.997 1.083l.334 4a1 1 0 00.996.917h.16z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Support1Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10-4c-1.448 0-2 1.052-2 1.5a1 1 0 11-2 0C8 7.948 9.448 6 12 6c1.995 0 4 1.257 4 3.5 0 1.577-.91 2.667-2.16 3.167a1.8 1.8 0 00-.654.43c-.143.157-.186.29-.186.403a1 1 0 11-2 0c0-1.442 1.183-2.324 2.097-2.69.578-.231.903-.64.903-1.31 0-.757-.684-1.5-2-1.5zm0 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Support2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8c0-.612.285-1.072.805-1.418C10.354 6.216 11.148 6 12 6c.852 0 1.646.216 2.195.582.52.346.805.806.805 1.418 0 .918-.553 1.73-1.49 2.172-1.096.52-2.51 1.62-2.51 3.328a1 1 0 102 0c0-.502.466-1.094 1.366-1.52C15.89 11.26 17 9.808 17 8c0-1.388-.715-2.428-1.695-3.082C14.354 4.284 13.148 4 12 4c-1.148 0-2.354.284-3.305.918C7.715 5.572 7 6.612 7 8a1 1 0 002 0zm3 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const BookmarkIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6a3 3 0 013-3h8a3 3 0 013 3v14a1 1 0 01-1.687.727L12 15.709l-5.313 5.018A1 1 0 015 20V6zm3-1a1 1 0 00-1 1v11.68l4.313-4.074a1 1 0 011.374 0L17 17.68V6a1 1 0 00-1-1H8z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ClipboardIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1a2 2 0 012 2h1a1 1 0 011 1h1a3 3 0 013 3v12a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3h1a1 1 0 011-1h1a2 2 0 012-2zM8 6a1 1 0 001 1h6a1 1 0 001-1h1a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Library2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 4a1 1 0 00-1-1h-8a1 1 0 00-1 1v1h5a3 3 0 013 3v5h1a1 1 0 001-1V4zm-2 11h1a3 3 0 003-3V4a3 3 0 00-3-3h-8a3 3 0 00-3 3v1H8a3 3 0 00-3 3v1H4a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-1h1a3 3 0 003-3v-1zm-2 1a1 1 0 01-1 1h-1v-5a3 3 0 00-3-3H7V8a1 1 0 011-1h8a1 1 0 011 1v8zm-5 5a1 1 0 001-1v-8a1 1 0 00-1-1H4a1 1 0 00-1 1v8a1 1 0 001 1h8z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const CollectionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5H7.5A2.5 2.5 0 005 7.5V9a2.5 2.5 0 002.5 2.5H9A2.5 2.5 0 0011.5 9V7.5A2.5 2.5 0 009 5zM7 7.5a.5.5 0 01.5-.5H9a.5.5 0 01.5.5V9a.5.5 0 01-.5.5H7.5A.5.5 0 017 9V7.5zM9 12.5H7.5A2.5 2.5 0 005 15v1.5A2.5 2.5 0 007.5 19H9a2.5 2.5 0 002.5-2.5V15A2.5 2.5 0 009 12.5zM7 15a.5.5 0 01.5-.5H9a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H7.5a.5.5 0 01-.5-.5V15zM15 5h1.5A2.5 2.5 0 0119 7.5V9a2.5 2.5 0 01-2.5 2.5H15A2.5 2.5 0 0112.5 9V7.5A2.5 2.5 0 0115 5zm0 2a.5.5 0 00-.5.5V9a.5.5 0 00.5.5h1.5A.5.5 0 0017 9V7.5a.5.5 0 00-.5-.5H15zM16.5 12.5H15a2.5 2.5 0 00-2.5 2.5v1.5A2.5 2.5 0 0015 19h1.5a2.5 2.5 0 002.5-2.5V15a2.5 2.5 0 00-2.5-2.5zm-2 2.5a.5.5 0 01.5-.5h1.5a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 01-.5-.5V15z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Collection2Icon = {
  Small: (props: IconProps) => (
    <IconWrapper {...props} size={12} viewBox="0 0 12 12">
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0h5a2 2 0 012 2v5a2 2 0 01-2 2V4a2 2 0 00-2-2H3a2 2 0 012-2zM2 3a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V5a2 2 0 00-2-2H2z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Medium: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.44 4h-2.88c-.404 0-.81-.004-1.214.029-.39.032-.88.109-1.38.364a3.6 3.6 0 00-1.574 1.573c-.254.5-.332.99-.364 1.38A9.698 9.698 0 008.002 8c-.002 0-.35.004-.656.029-.39.032-.88.109-1.38.364a3.6 3.6 0 00-1.574 1.573c-.254.5-.332.99-.364 1.38C4 11.697 4 12.106 4 12.503v2.997c0 .397 0 .805.028 1.155.032.39.11.88.364 1.38a3.6 3.6 0 001.574 1.574c.5.255.99.332 1.38.364.404.033.81.028 1.214.028h2.88c.405 0 .81.005 1.214-.028.39-.032.88-.11 1.38-.364a3.6 3.6 0 001.574-1.573c.254-.5.332-.99.364-1.381.024-.305.028-.654.028-.656.229-.003.451-.01.654-.026.39-.032.88-.11 1.38-.364a3.6 3.6 0 001.574-1.573c.254-.5.332-.99.364-1.381.028-.35.028-.758.028-1.155V8.502c0-.397 0-.806-.028-1.156-.032-.39-.11-.88-.364-1.38a3.6 3.6 0 00-1.574-1.573c-.5-.255-.99-.332-1.38-.364C16.25 3.996 15.844 4 15.44 4zm.56 9.998v-1.496c0-.397 0-.806-.028-1.155-.032-.391-.11-.881-.364-1.381a3.6 3.6 0 00-1.574-1.573c-.5-.255-.99-.332-1.38-.364C12.304 8 11.895 8 11.499 8h-1.497c.008-.54.039-.864.172-1.126a1.6 1.6 0 01.7-.7C11.216 6 11.664 6 12.56 6h2.88c.896 0 1.344 0 1.686.175a1.6 1.6 0 01.7.699c.174.342.174.79.174 1.686v2.88c0 .896 0 1.344-.174 1.687a1.6 1.6 0 01-.7.699c-.262.133-.586.165-1.126.172zm-2-1.438c0-.896 0-1.344-.174-1.686a1.6 1.6 0 00-.7-.7C12.784 10 12.336 10 11.44 10H8.56c-.896 0-1.344 0-1.686.175a1.6 1.6 0 00-.7.699C6 11.216 6 11.664 6 12.56v2.88c0 .896 0 1.344.174 1.687a1.6 1.6 0 00.7.699c.342.174.79.174 1.686.174h2.88c.896 0 1.344 0 1.686-.174a1.6 1.6 0 00.7-.7c.174-.342.174-.79.174-1.686v-2.88z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const ImageIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-1a1 1 0 00-1 1v9.586l3.793-3.793a1 1 0 011.414 0L11 14.586l5.293-5.293a1 1 0 011.414 0L20 11.586V7a1 1 0 00-1-1H5zm14 12H5.414L8.5 14.914l1.793 1.793a1 1 0 001.414 0L17 11.414l3 3V17a1 1 0 01-1 1zM7.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const GalleryIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a3 3 0 00-3 3v8a2 2 0 002 2V7a1 1 0 011-1h13a2 2 0 00-2-2H5zm4 4a3 3 0 00-3 3v7a3 3 0 003 3h10a3 3 0 003-3v-7a3 3 0 00-3-3H9zm-1 3a1 1 0 011-1h10a1 1 0 011 1v2.586l-1.293-1.293a1 1 0 00-1.414 0L14 15.586l-.793-.793a1 1 0 00-1.414 0l-3.676 3.676A.996.996 0 018 18v-7zm10 3.414l2 2V18a1 1 0 01-1 1h-8.586l2.086-2.086.793.793a1 1 0 001.414 0L18 14.414zM10.5 14a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Chat1Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.155 13.521l.49-.109c.444.237.928.41 1.438.504a7.005 7.005 0 015.833-5.833 5.002 5.002 0 10-9.328 3.271l-.11.49L4 14l2.155-.479zm9.783-5.459A7.001 7.001 0 102.49 11.576l-.442 1.99a2 2 0 002.386 2.386l1.99-.442c.52.206 1.068.351 1.638.428a7.001 7.001 0 009.514 5.572l1.99.442a2 2 0 002.386-2.386l-.442-1.99a7.001 7.001 0 00-5.572-9.514zm1.416 11.35l.49.11L20 20l-.479-2.155-.109-.49a5 5 0 10-2.058 2.058z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Chat2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12a9 9 0 1117.184 3.75l.748 3.809a1.17 1.17 0 01-1.373 1.374l-3.812-.748A9 9 0 013 12zm9-7a7 7 0 103.16 13.248 1 1 0 01.645-.09l2.927.574-.575-2.924a1 1 0 01.09-.645A7 7 0 0012 5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const QRCodeIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2H2v9h9V2zM9 4H4v5h5V4zM5 5h3v3H5V5zm14 0h-3v3h3V5zm3-3h-9v9h9V2zm-2 2h-5v5h5V4zM8 16H5v3h3v-3zm14 1h-2v-2h2v-2h-4v5h-5v4h2v-2h2v2h5v-5zM2 13h9v9H2v-9zm11 4v-4h4v4h-4zm-9-2h5v5H4v-5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Journal1Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4 4h-.043c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.961.487A5 5 0 004.545 6.73c-.302.592-.428 1.233-.487 1.961C4 9.4 4 10.273 4 11.357V12.643c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 002.185 2.185c.592.302 1.233.428 1.961.487C9.4 20 10.273 20 11.357 20H12.643c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 002.185-2.185c.302-.592.428-1.232.487-1.961C20 14.6 20 13.727 20 12.643V10.6a1 1 0 10-2 0v2c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 01-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051h-1.2c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 01-1.311-1.311c-.134-.263-.226-.611-.276-1.216C6.001 14.529 6 13.736 6 12.6v-1.2c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 011.311-1.311c.263-.134.611-.226 1.216-.276C9.471 6.001 10.264 6 11.4 6h2a1 1 0 100-2h-2zm1.287 8.727l7.02-7.02a1 1 0 00-1.414-1.414l-7.02 7.02c-.181.181-.338.384-.468.605L9.581 14.01c-.157.267.143.567.41.41l2.09-1.224c.222-.13.425-.287.606-.468z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Journal2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3a1 1 0 011-1h11a4 4 0 014 4v12a4 4 0 01-4 4H5a1 1 0 01-1-1v-3a1 1 0 110-2v-3a1 1 0 110-2V8a1 1 0 010-2V3zm2 15a1 1 0 100-2v-3a1 1 0 100-2V8a1 1 0 000-2V4h7v16H6v-2zm10 2h-1V4h1a2 2 0 012 2v12a2 2 0 01-2 2z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const EditIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12a8 8 0 11-5.738-7.676L10.627 7.96a3 3 0 00-.725 1.173l-1.85 5.552a1 1 0 001.264 1.265l5.552-1.851a3 3 0 001.173-.725l3.635-3.635A8 8 0 0120 12zm-1.2-4.215l-4.173 4.174a1 1 0 01-.391.242l-2.67.89a2.518 2.518 0 00-.657-.656l.89-2.67a1 1 0 01.242-.392L16.215 5.2a8.041 8.041 0 012.586 2.586zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Edit2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.752 15.437l-.738 2.212a.266.266 0 00.337.337l2.212-.738a2.13 2.13 0 00.833-.514l6.521-6.521a2.665 2.665 0 00-2.13-2.13l-6.52 6.521a2.13 2.13 0 00-.515.833zM14.646 7.224a3.739 3.739 0 012.13 2.13l.783-.783a1.506 1.506 0 00-2.13-2.13l-.783.783z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ReflectionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.586 4a2 2 0 012.828 0L20 6.586a2 2 0 010 2.828l-8.959 8.96a3 3 0 01-1.173.724l-5.552 1.85a1 1 0 01-1.265-1.265l.985-2.952.004-.013.862-2.586a3 3 0 01.725-1.173L14.586 4zM7.54 17.766a3.513 3.513 0 00-1.307-1.307l.565-1.695a1 1 0 01.242-.39L13 8.413 15.586 11l-5.96 5.959a1 1 0 01-.39.242l-1.695.565zM16 5.414L14.414 7 17 9.586 18.586 8 16 5.414z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SettingsIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.27 4.032l-.075.209a3 3 0 01-4.114 1.704L6.88 5.85a8.056 8.056 0 00-1.03 1.03l.095.201a3 3 0 01-1.704 4.114l-.21.075a8.337 8.337 0 000 1.457l.21.074a3 3 0 011.704 4.115l-.095.2c.311.375.656.72 1.03 1.031l.2-.095a3 3 0 014.115 1.704l.075.209c.482.043.975.043 1.457 0l.074-.21a3 3 0 014.115-1.703l.2.095a8.054 8.054 0 001.031-1.03l-.095-.201a3 3 0 011.704-4.115l.209-.074a8.343 8.343 0 000-1.457l-.21-.075a3 3 0 01-1.703-4.114l.095-.201a8.054 8.054 0 00-1.03-1.03l-.201.095A3 3 0 0112.8 4.241l-.074-.21a8.338 8.338 0 00-1.457 0zm-.898-1.902a10.225 10.225 0 013.253 0 1 1 0 01.78.652l.28.789a1 1 0 001.372.568l.756-.36a1 1 0 011.013.092 10.053 10.053 0 012.3 2.3 1 1 0 01.091 1.013l-.36.756a1 1 0 00.569 1.371l.789.28a1 1 0 01.652.781c.173 1.06.173 2.192 0 3.253a1 1 0 01-.652.78l-.789.28a1 1 0 00-.568 1.372l.359.756a1 1 0 01-.09 1.013 10.053 10.053 0 01-2.301 2.3 1 1 0 01-1.013.091l-.756-.36a1 1 0 00-1.371.569l-.28.789a1 1 0 01-.781.652c-1.06.173-2.192.173-3.253 0a1 1 0 01-.78-.652l-.28-.789a1 1 0 00-1.372-.568l-.756.36a1 1 0 01-1.013-.092 10.052 10.052 0 01-2.3-2.3 1 1 0 01-.091-1.013l.359-.756a1 1 0 00-.568-1.371l-.789-.28a1 1 0 01-.652-.781 10.225 10.225 0 010-3.253 1 1 0 01.652-.78l.789-.28a1 1 0 00.568-1.372l-.36-.756a1 1 0 01.092-1.013 10.052 10.052 0 012.3-2.3 1 1 0 011.013-.091l.756.359a1 1 0 001.371-.568l.28-.789a1 1 0 01.781-.652z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15a3 3 0 100-6 3 3 0 000 6zm0 2a5 5 0 100-10 5 5 0 000 10z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SessionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm1 4a1 1 0 100 2h12a1 1 0 100-2H6z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ActivityIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.486 8.672l1.075 2.51A3 3 0 0017.32 13H20a1 1 0 100-2h-2.681a1 1 0 01-.92-.606l-1.778-4.149c-.597-1.394-2.649-1.122-2.863.379l-1.244 8.704-1.075-2.51A3 3 0 006.68 11H4a1 1 0 100 2h2.681a1 1 0 01.92.606l1.777 4.149c.598 1.394 2.65 1.122 2.864-.379l1.244-8.704z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ParishIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a8 8 0 00-4.347 14.717L11 13.697V11H9a1 1 0 110-2h2V7a1 1 0 112 0v2h2a1 1 0 110 2h-2v2.697l3.347 5.02A8 8 0 0012 4zm0 16a7.99 7.99 0 01-2.527-.407L12 15.803l2.527 3.79A7.991 7.991 0 0112 20zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const ConfessionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3a7.002 7.002 0 00-6.903 5.835 1 1 0 101.972.33A5.002 5.002 0 019 5h6a5 5 0 015 5v10a1 1 0 102 0V10a7 7 0 00-7-7H9zm2 6a2 2 0 00-1.034 3.712c.026.011.051.024.076.038.284.155.609.243.958.243a1.99 1.99 0 001.412-.583.962.962 0 01.056-.052A2 2 0 0011 9zm-4 2c0 .981.353 1.88.94 2.576A5.985 5.985 0 006 17.994v2c0 .472.327.787.704 1.013.224.134.541.289.98.435C8.559 21.734 9.92 22 12 22c2.08 0 3.441-.266 4.316-.558.439-.146.756-.3.98-.435.38-.227.704-.534.704-1.014v-2a5.999 5.999 0 00-3.34-5.378A4 4 0 107 11zm1 6.994c0-1.014.377-1.94 1-2.647V18c.5 0 1.5 0 2-.006V15c.729 0 1.412-.195 2-.535V18h2v-2.652c.622.705 1 1.632 1 2.646v1.431c-.086.037-.19.078-.316.12-.625.208-1.764.455-3.684.455-1.92 0-3.059-.247-3.684-.455a4.07 4.07 0 01-.316-.12v-1.431zM3 13a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MassIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.02 4A2.5 2.5 0 009.87 7.806c.038.063.068.128.091.194h4.068c.022-.054.05-.108.082-.16A2.5 2.5 0 0012.02 4zm4.223 4a4.5 4.5 0 10-8.486 0H6.06A1.06 1.06 0 005 9.06c0 3.13 2.107 5.763 4.952 6.634A5 5 0 018 19l-1.59 1.193a.993.993 0 00-.408.752A.998.998 0 007.011 22h9.976c.023 0 .045 0 .067-.002a.994.994 0 00.891-.674.998.998 0 00-.355-1.13L16 19a5 5 0 01-1.952-3.306C16.893 14.824 19 12.191 19 9.06A1.06 1.06 0 0017.94 8h-1.697zm-4.171 8a5.712 5.712 0 01-.144 0A7 7 0 019.9 20h4.202a7.001 7.001 0 01-2.03-4zM12 14c-2.417 0-4.459-1.73-4.908-4h9.816c-.449 2.27-2.49 4-4.908 4z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const DayIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4a1 1 0 112 0v1a1 1 0 11-2 0V4zm1 11a3 3 0 100-6 3 3 0 000 6zm0 2a5 5 0 100-10 5 5 0 000 10zm0 1a1 1 0 00-1 1v1a1 1 0 102 0v-1a1 1 0 00-1-1zm-8-5a1 1 0 110-2h1a1 1 0 110 2H4zm14-1a1 1 0 001 1h1a1 1 0 100-2h-1a1 1 0 00-1 1zm-.909-6.364a.9.9 0 011.273 1.273l-.637.636a.9.9 0 01-1.272-1.273l.636-.636zM7.545 16.455a.9.9 0 00-1.273 0l-.636.636a.9.9 0 101.273 1.273l.636-.637a.9.9 0 000-1.272zM5.636 6.909a.9.9 0 011.273-1.273l.636.636a.9.9 0 01-1.273 1.273l-.636-.636zm10.819 9.546a.9.9 0 000 1.273l.636.636a.9.9 0 101.273-1.273l-.637-.636a.9.9 0 00-1.272 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const NightIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7a8 8 0 01-8 8c-.22 0-.434-.017-.637-.045C7.451 16.215 9.103 17 11 17a6 6 0 006-6c0-1.897-.785-3.549-2.045-4.637.028.203.045.417.045.637zm-2 0a6 6 0 01-6 6c-.562 0-1.172-.212-1.708-.4L5 12.5c-1.08-.362-1.853.57-1.5 1.5 1.146 3.016 4.082 5 7.5 5a8 8 0 008-8c0-3.418-1.984-6.354-5-7.5-1.11-.422-1.835.5-1.5 1.5l.1.292c.188.536.4 1.146.4 1.708z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const TransferIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.707 8.293a1 1 0 010 1.414L4.414 12l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm10.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L19.586 12l-2.293-2.293a1 1 0 010-1.414zM8.25 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM17 12a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5 1.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const LocationIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11a6 6 0 1112 0c0 3.157-2.332 5.9-6 8.743C8.332 16.899 6 14.157 6 11zm6-8a8 8 0 00-8 8c0 4.406 3.412 7.809 7.4 10.8a1 1 0 001.2 0C16.588 18.809 20 15.406 20 11a8 8 0 00-8-8zm-2 8a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Timer2Icon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3a1 1 0 011-1c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-2.76 1.12-5.26 2.926-7.068a1 1 0 011.415 1.413A8 8 0 1013 4.062V6a1 1 0 11-2 0V3zm2.03 10.03a1.374 1.374 0 00-.128-2.056L8.96 7.908A.75.75 0 007.908 8.96l3.066 3.942a1.374 1.374 0 002.056.128z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const UpwardTrendIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H19C19.5523 7 20 7.44772 20 8V12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12V10.4142L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071L10 12.4142L5.70711 16.7071C5.31658 17.0976 4.68342 17.0976 4.29289 16.7071C3.90237 16.3166 3.90237 15.6834 4.29289 15.2929L9.29289 10.2929C9.68342 9.90237 10.3166 9.90237 10.7071 10.2929L13 12.5858L16.5858 9H15Z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const PermissionIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path d="M15.207 11.207a1 1 0 00-1.414-1.414L11 12.586l-.793-.793a1 1 0 00-1.414 1.414l1.5 1.5a1 1 0 001.414 0l3.5-3.5z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.671 5.027L4 5.306V13c0 1.406.689 2.594 1.376 3.453.71.886 1.606 1.658 2.424 2.272a23.834 23.834 0 003.215 2.017l.062.032.019.01.008.004a2.003 2.003 0 001.791 0l.003-.001.006-.003.02-.01.061-.032a23.886 23.886 0 00.96-.53 23.845 23.845 0 002.255-1.487c.819-.614 1.715-1.386 2.424-2.273C19.311 15.594 20 14.407 20 13V5.306l-1.671-.279c-1.31-.218-2.667-.665-3.73-1.079a25.626 25.626 0 01-1.686-.728l-.019-.01L12 2.765l-.894.447-.02.01a25.612 25.612 0 01-1.686.728c-1.062.413-2.42.86-3.729 1.078zm7.224 15.761L12 19l.895 1.788zM12 19c-.894 1.789-.895 1.788-.895 1.788L12 19zm0 0s-6-3-6-6V7c3-.5 6-2 6-2s3 1.5 6 2v6c0 3-6 6-6 6z"
      />
    </svg>
  </IconWrapper>
);

export const CommunityAltIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        clipRule="evenodd"
        d="M16.5 6.63153V8.49995C16.5 9.88066 15.3807 10.9999 14 10.9999H10C8.61929 10.9999 7.5 9.88066 7.5 8.49995V6.63153C7.5 5.29421 8.36327 4.31224 8.84891 3.83347C9.42172 3.26875 10.074 2.82664 10.4871 2.56867C11.4148 1.98932 12.5852 1.98932 13.5129 2.56867C13.926 2.82664 14.5783 3.26875 15.1511 3.83347C15.6367 4.31224 16.5 5.29421 16.5 6.63153ZM11.5465 4.26504C10.8259 4.71507 9.5 5.6733 9.5 6.63153V8.49995C9.5 8.77609 9.72386 8.99995 10 8.99995H14C14.2761 8.99995 14.5 8.77609 14.5 8.49995V6.63153C14.5 5.6733 13.1741 4.71507 12.4535 4.26504C12.1741 4.09053 11.8259 4.09053 11.5465 4.26504Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11 16.6315V18.4999C11 19.8807 9.88071 20.9999 8.5 20.9999H4.5C3.11929 20.9999 2 19.8807 2 18.4999V16.6315C2 15.2942 2.86327 14.3122 3.34891 13.8335C3.92172 13.2687 4.57401 12.8266 4.98709 12.5687C5.91478 11.9893 7.08522 11.9893 8.01291 12.5687C8.42599 12.8266 9.07828 13.2687 9.65109 13.8335C10.1367 14.3122 11 15.2942 11 16.6315ZM6.04649 14.265C5.32589 14.7151 4 15.6733 4 16.6315V18.4999C4 18.7761 4.22386 18.9999 4.5 18.9999H8.5C8.77614 18.9999 9 18.7761 9 18.4999V16.6315C9 15.6733 7.67411 14.7151 6.95351 14.265C6.67407 14.0905 6.32593 14.0905 6.04649 14.265Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M22 18.4999V16.6315C22 15.2942 21.1367 14.3122 20.6511 13.8335C20.0783 13.2687 19.426 12.8266 19.0129 12.5687C18.0852 11.9893 16.9148 11.9893 15.9871 12.5687C15.574 12.8266 14.9217 13.2687 14.3489 13.8335C13.8633 14.3122 13 15.2942 13 16.6315V18.4999C13 19.8807 14.1193 20.9999 15.5 20.9999H19.5C20.8807 20.9999 22 19.8807 22 18.4999ZM15 16.6315C15 15.6733 16.3259 14.7151 17.0465 14.265C17.3259 14.0905 17.6741 14.0905 17.9535 14.265C18.6741 14.7151 20 15.6733 20 16.6315V18.4999C20 18.7761 19.7761 18.9999 19.5 18.9999H15.5C15.2239 18.9999 15 18.7761 15 18.4999V16.6315Z"
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const SettingsAltIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        clipRule="evenodd"
        d="M12.0001 4.30945L5.33984 8.15475L5.33984 15.8453L12.0001 19.6906L18.6604 15.8453L18.6604 8.15475L12.0001 4.30945ZM16.0001 12.0001C16.0001 14.2092 14.2093 16.0001 12.0001 16.0001C9.79098 16.0001 8.00012 14.2092 8.00012 12.0001C8.00012 9.79092 9.79098 8.00005 12.0001 8.00005C14.2093 8.00005 16.0001 9.79092 16.0001 12.0001ZM11.0001 2.5774C11.6189 2.22013 12.3813 2.22013 13.0001 2.5774L19.6604 6.4227C20.2792 6.77996 20.6604 7.44022 20.6604 8.15475V15.8453C20.6604 16.5599 20.2792 17.2201 19.6604 17.5774L13.0001 21.4227C12.3813 21.78 11.6189 21.78 11.0001 21.4227L4.33984 17.5774C3.72104 17.2201 3.33984 16.5599 3.33984 15.8453V8.15475C3.33984 7.44022 3.72104 6.77996 4.33984 6.4227L11.0001 2.5774ZM14.0001 12.0001C14.0001 13.1046 13.1047 14.0001 12.0001 14.0001C10.8956 14.0001 10.0001 13.1046 10.0001 12.0001C10.0001 10.8955 10.8956 10.0001 12.0001 10.0001C13.1047 10.0001 14.0001 10.8955 14.0001 12.0001Z"
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const SwapIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path d="M8.707 5.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L7.414 9H19a1 1 0 100-2H7.414l1.293-1.293zM15.293 13.707a1 1 0 011.414-1.414l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L16.586 17H5a1 1 0 110-2h11.586l-1.293-1.293z" />
    </svg>
  </IconWrapper>
);

export const FriendsIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg>
      <path
        clipRule="evenodd"
        d="M5.89853 11.9221C4.74198 11.0063 4 9.5898 4 8C4 5.23858 6.23858 3 9 3C10.1255 3 11.1646 3.37258 11.9999 3.99971C12.8356 3.37198 13.8743 3 15 3C17.7614 3 20 5.23858 20 8C20 9.5898 19.258 11.0063 18.1015 11.9221C18.8404 12.3898 19.4956 13.0138 20.0426 13.7431C21.2703 15.38 22 17.5954 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20C2 17.5954 2.72973 15.38 3.95736 13.7431C4.5044 13.0138 5.15957 12.3898 5.89853 11.9221ZM15 5C13.3431 5 12 6.34315 12 8C12 9.65685 13.3431 11 15 11C16.6569 11 18 9.65685 18 8C18 6.34315 16.6569 5 15 5ZM9 11C7.34315 11 6 9.65685 6 8C6 6.34315 7.34315 5 9 5C9.61663 5 10.1894 5.18544 10.6662 5.50467C10.2695 6.19213 10.0317 6.9828 10.003 7.82652C10.001 7.8841 10 7.94194 10 8C10 8.05526 10.0009 8.11031 10.0027 8.16514C10.0302 9.01199 10.2682 9.80561 10.6662 10.4953C10.1894 10.8146 9.61663 11 9 11ZM12.6318 13.8454C13.3579 13.2921 14.1695 13 15 13C16.2715 13 17.4989 13.6849 18.4426 14.9431C19.227 15.989 19.7832 17.3981 19.9488 19H10.0512C10.1556 17.9902 10.4152 17.0571 10.7892 16.2433C11.2507 15.2405 11.8847 14.422 12.6107 13.8621C12.6179 13.8566 12.6249 13.851 12.6318 13.8454ZM8.97796 15.3949C9.3446 14.5996 9.80588 13.8792 10.3473 13.2615C9.91319 13.0891 9.46122 13 9 13C7.72847 13 6.50108 13.6849 5.55736 14.9431C4.77296 15.989 4.2168 17.3981 4.05121 19H8.04247C8.15341 17.7014 8.47838 16.4776 8.97796 15.3949Z"
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const SubtitlesIcon = {
  Outline: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 16C4 17.1046 4.89543 18 6 18H14L17 20V18H18C19.1046 18 20 17.1046 20 16V8C20 6.89543 19.1046 6 18 6H6C4.89543 6 4 6.89543 4 8V16ZM22 16C22 17.8638 20.7252 19.4299 19 19.874V20C19 20.7376 18.594 21.4153 17.9437 21.7633C17.2934 22.1114 16.5043 22.0732 15.8906 21.6641L13.3944 20H6C3.79086 20 2 18.2091 2 16V8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V16ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H9C9.55229 13 10 12.5523 10 12C10 11.4477 9.55229 11 9 11H7ZM6 15C6 14.4477 6.44772 14 7 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H7C6.44772 16 6 15.5523 6 15ZM15 15C15 14.4477 15.4477 14 16 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H16C15.4477 16 15 15.5523 15 15ZM11 12C11 11.4477 11.4477 11 12 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H12C11.4477 13 11 12.5523 11 12Z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper {...props}>
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 16C22 17.8638 20.7252 19.4299 19 19.874V20C19 20.7376 18.594 21.4153 17.9437 21.7633C17.2934 22.1114 16.5043 22.0732 15.8906 21.6641L13.3944 20H6C3.79086 20 2 18.2091 2 16L2 8C2 5.79086 3.79086 4 6 4L18 4C20.2091 4 22 5.79086 22 8V16ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H9C9.55229 13 10 12.5523 10 12C10 11.4477 9.55229 11 9 11H7ZM6 15C6 14.4477 6.44772 14 7 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H7C6.44772 16 6 15.5523 6 15ZM15 15C15 14.4477 15.4477 14 16 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H16C15.4477 16 15 15.5523 15 15ZM11 12C11 11.4477 11.4477 11 12 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H12C11.4477 13 11 12.5523 11 12Z"
          fill={props.fill}
        />
      </svg>
    </IconWrapper>
  ),
};

export const GivingIcon = (props: IconProps) => (
  <IconWrapper {...props}>
    <svg fill="none">
      <path d="M0 0H24V24H0z" />
      <path
        d="M12 8a1 1 0 00-1 1v1h-1a1 1 0 100 2h1v3a1 1 0 102 0v-3h1a1 1 0 100-2h-1V9a1 1 0 00-1-1z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.387 16a8.273 8.273 0 10-14.775 0H4a2 2 0 100 4h16a2 2 0 100-4h-.613zm-4.824 2A6.275 6.275 0 0012 6a6.273 6.273 0 00-2.563 12h5.127z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);
